import { recipient } from '@/api/recipients.js'
import { senior } from '@/api/seniors.js'
import { common } from '@/api/common'
import { sync } from '@/api/bosync'
import store from '@/store'
import Vue from 'vue'

const pattern = /[0-9]/
let res = null

export const recipients = {
    namespaced: true,
    state: {
        recipients: null,
        simpleList: null,
        simpleSchedule: null,
        copiedRecipients: null,

        //수급자 필터, 검색, 선택된 수급자
        listType: null,
        state: null,
        searchWord: null,
        selected: [],

        //수급자
        recipientDetail: null,
        deputyInfo: null,
        guardianInfos: null,
        mailingInfos: null,
        contractInfo: null, //현재계약
        suadeContractFileList: null,
        staffInfo: null,
        visitingNursing: null,
        visitingNursingYn: null,
        salaryInfo: null, // 급여이용계획
        prevMonthChargeInfo: null, // previously mounth personal charge info
        thisMonthChargeInfo: null, // this month personal charge info
        nextChargeInfo: null, // next month personal charge info

        //수급자메모
        slipRecipientInfo: null,
        recipientMemo: null,

        //본인부담금률 변경내역
        personalChargeHistory: null,

        //수급계약서 정보
        contracts: null,

        //수급계약 갱신정보
        renewContracts: null,

        //수급계약 재계약정보
        renewAll: null,

        //수급계약서 리스트(멀티)
        recipientContractList: null,

        //수급계약 갱신리스트
        contractChange: null,

        //RFID 정보
        salaryOfferLogRfidList: null,

        //본인부담금 정보
        personalCopay: null,
        selectCopaySuadeIdx: null,
        personalCopayList: null,
        processStatus: false,
        processPayload: null,
        processName: null,

        //급여이용계획 정보
        salarys: null,
        salaryCaregivers: null,

        //기초평가리스트
        assessments: null,
        assessmentYear: null,
        needs: null,
        beds: null,
        falls: null,

        //개인별장기이용계획서
        standardUsePlan: null,

        //개인별장기이용 변경계획서
        standardUseChange: null,
        salaryNumberCodes: null,

        //수행일지(상담일지)
        recipientPerform: null,

        //급여제공계획서
        serviceProvidePlan: null, // main info selection
        planNeedAreas: null,
        planNeedContents: null,
        // serviceplan group target item and sub area
        planGroupTargetItems: null,
        planSubAreaItems: null,

        //급여제공기록지
        serviceLog: null,

        //상태기록지
        stateReportList: null,

        //상담일지
        counselList: null,

        //물품사용일지
        itemUsageList: null,
        itemUsageLog: null,

        //간호업무 종합일지
        synthesisList: null,

        //급여제공, 상태기록지, 상담 등 일정선택하고 작성페이지로 이동시 필요한 정보
        tmpSelectSchedule: null,

        //투약관리일지
        medicineLogList: null,
        medicineLog: null,
        searchMedicine: null,
        searchHospital: null,

        // 수급자 한명 전체 입금액
        aRecipientDeposits: null,
        selectedModel: null,

        // 방문간호지시서 리스트 
        submitFileList: null,

        // 수급자 필수접수서류 현황
        eachEssentialFiles: null,

        changeNotice: null,

        // 수급자의 요양,목욕 최신계약조회
        latestCare: null,
        latestBath: null,

        //욕조소독일지
        disinfectList: null,

        // be added since 2021.12.23 업무수행일지(일반)목록
        performances: null,
        cogPerformances: null,
        // 업무수행일지(NEW) 이전기록지 불러오기 — 한 수급자 기준 전체 기록
        recipientDiaryAll: null,
        // 방문예정일시: 캘린더 조회 항목
        performPlanList: null,

        // 요양보호사(셀렉트박스) 리스트
        caregiverList: null,

        // 업무진행전체현황
        statusWorkingProgress: null,
        statusUsingAmount: null,

        //수가가산금액
        additionSupportAmount: null,

        // dashboard
        dashboard: null,
        endContractList: null,
        gradeCount: null,
        ltcareBasisList: null,
        abnormalContractList: null,
        ltcareGradeCount: null,
        newContractRecipientList: null,
        performLogList: null,
        periodEndCount: null,
        receiverStateCount: null,
        recipientCount: null,
        rfidTagList: null,
        moveList: null, //타기관 이동 수급자 목록
        postponeList: null, //수급보류 수급자 목록
        moveHospitalList: null, //요양(병)원 수급자 목록
        deathList: null, //사망 수급자 목록
        suadeContract11List: null,

        notMatchReport: null,

        //급여일정관리 메뉴의 급여일정표
        offerService: null,

        //RFID태그 에러 내역 조회 (한달씩 조회)
        rfidErrorRecipientList: null,
        rfidErrorStaffList: null,
        rfidCompareDay: null,

        //수급자의 SMS수신자 정보
        smsReceiver: null,

        //본인부담금 문자 발송 리스트
        personalPushList: null,
        smsDefault: null,
        smsSendPhone: null,

        //입금내역전체보기
        allDepositList: null,

        //개별 입금내역
        eachDepositList: null,

        // 급여일정관리 캘린더
        offerList: null,
        staffOtherSchedule: null,
        allScheduleInfo: null,
        ltcareMonthUseLimit: null,
        offerStaffList: null,
        numbersType: null,
        servicePlan: null,

        //동기화 에러내역
        ServiceSyncError: null,

        // 수급자 신규캘린더의 임시 종사자 리스트
        tmpStaff: [],

        calendarIdx: null,

        recipientSimple: null,
        familyYn: false,

        //신규 수급자계약 리스트
        contractList: null,
        //수급계약서 급여종류 선택 유형
        contractServiceType: null,

        //본부금 cms
        cmsMemberList: null,
        cmsPaymentList: null,

        idxGroup: [],

        //급여제공계획변경 사유서
        servicePlanList: null,

        //응급상황기록부 리스트
        emergencyLog: null,

    },
    mutations: {
        SET_TMP_STAFF(state, payload) {
            let arr = []
            state.tmpStaff.forEach(item => {
                arr.push(String(item.staffUserIdx))
            })
            payload.forEach(item => {
                if (!arr.includes(String(item.staffUserIdx))) {
                    arr.push(String(item.staffUserIdx))
                    state.tmpStaff.push(item)
                }
            })
        },
        SET_TMP_STAFF_SERVICE(state, payload) {
            let arr = []
            state.tmpStaff.forEach(item => {
                arr.push(String(item.staffUserIdx))
            })

            if (payload) {
                payload.forEach(item => {
                    if (item.staffList) {
                        item.staffList.forEach(staff => {
                            if (!arr.includes(String(staff.staffUserIdx))) {
                                arr.push(String(staff.staffUserIdx))
                                state.tmpStaff.push(staff)
                            }
                        })
                    }
                })
            }
        },
        RECIPIENT(state, payload) {
            state.recipients = payload.list
        },
        RECIPIENT_SIMPLE_LIST(state, payload) {
            state.simpleList = payload.recipientList
        },
        RECIPIENT_SCHEDULE(state, payload) {
            state.simpleSchedule = payload.receiverOfferScheduleList
        },
        RESET_SIMPLE_LIST(state, payload) {
            state.simpleList = null
            state.simpleSchedule = null
        },
        RECIPIENT_CONTRACT(state, payload) {
            state.contracts = payload
        },
        RESET_SELECT(state) {
            //리스트
            state.listType = null
            state.state = null
            state.searchWord = null
            state.selected = []
            state.copiedRecipients = null

            // TODO: 다른페이지(수급자 -> 시니어 등) 이동 시 기존에 조회했던 상세정보를 모두 지운다.
            //수급자
            state.recipientDetail = null
            state.deputyInfo = null
            state.guardianInfos = null
            state.mailingInfos = null
            state.contractInfo = null
            state.recipientMemo = null
            state.suadeContractFileList = null
            state.staffInfo = null
            state.visitingNursing = null
            state.visitingNursingYn = null
            state.salaryInfo = null
        },
        REGIST_RECIPIENT_IMAGE(state, payload) {
            state.recipientDetail.userImagePath = payload.userInfo.userImagePath
            let obj = state.recipients.filter(item => item.userIdx === payload.userInfo.userIdx)
            obj[0].userImagePath = payload.userInfo.userImagePath


            if (state.slipRecipientInfo.userIdx === payload.userInfo.userIdx)
                state.slipRecipientInfo.userImagePath = payload.userInfo.userImagePath
        },
        DELETE_RECIPIENT_IMAGE(state, payload) {
            state.recipientDetail.userImagePath = null
            let obj = state.recipients.filter(item => item.userIdx === payload)
            obj[0].userImagePath = null
        },
        RECIPIENT_DETAIL_INFO(state, payload) {
            state.recipientDetail = payload.recipientInfo
            let pre = state.recipientDetail.rno3 ? atob(decodeURIComponent(state.recipientDetail.rno3)) : null
            let back = state.recipientDetail.rnoEnc ? atob(decodeURIComponent(state.recipientDetail.rnoEnc)) : null
            state.recipientDetail['rnoSum'] = pre ? pre + back : null

            state.deputyInfo = payload.deputyInfo
            state.guardianInfos = payload.guardianInfos
            state.mailingInfos = payload.mailingInfos
            state.contractInfo = payload.suadeContractInfo
            state.suadeContractFileList = payload.suadeContractFileList
            state.staffInfo = payload.staffInfo
            state.visitingNursing = payload.visitingNursing
            state.visitingNursingYn = payload.visitingNursingYn
            state.salaryInfo = payload.salaryOb
            state.prevMonthChargeInfo = payload.prevMonthPersonal
            state.thisMonthChargeInfo = payload.thisMonthPersonal
        },
        UPDATE_RECIPIENT_DETAIL_INFO(state, payload) {
            state.recipientDetail = payload.recipientInfo
            state.deputyInfo = payload.deputyInfo
            state.guardianInfos = payload.guardianInfos
            state.mailingInfos = payload.mailingInfos
        },
        RECIPIENT_MEMO(state, payload) {
            state.slipRecipientInfo = payload.receiverInfo
            state.recipientMemo = payload.userMemoList
        },
        REGIST_RECIPIENT_MEMO(state, payload) {
            if (state.slipRecipientInfo.homeReceiverIdx === payload.memo.homeReceiverIdx) {
                if (!state.recipientMemo) state.recipientMemo = []
                state.recipientMemo.unshift(payload.memo)
            }
        },
        UPDATE_RECIPIENT_MEMO(state, payload) {
            let index = state.recipientMemo.findIndex(item => item.userConsultIdx === payload.midx)
            state.recipientMemo.splice(index, 1, payload.memo)
        },
        DELETE_RECIPIENT_MEMO(state, payload) {
            let index = state.recipientMemo.findIndex(item => item.userConsultIdx === payload)
            state.recipientMemo.splice(index, 1)
            if (!state.recipientMemo.length) state.recipientMemo = null
        },
        DELETE_RECIPIENT_MEMO_FILE(state, payload) {
            let files = state.recipientMemo[payload.mIndex].userConsultFileList
            files.splice(payload.index, 1)
            if (!files.length) files = null
        },
        SET_RECIPIENT_STATE(state, payload) {
            state.state = payload
        },
        SET_RECIPIENT_LIST_TYPE(state, payload) {
            state.listType = payload
        },
        SET_SEARCH_WORD(state, payload) {
            state.searchWord = payload
        },
        CLEAR_RECIPIENT_SELECTED(state) {
            state.selected = []
        },
        ALL_RECIPIENT_SELECTED(state) {
            if (!state.copiedRecipients) return

            if (state.selected.length) {
                state.selected = []
            } else {
                state.copiedRecipients.forEach(item => {
                    state.selected.push({
                        userIdx: item.userIdx,
                        homeSeniorIdx: item.homeSeniorIdx,
                        suadeContractIdx: item.suadeContractIdx,
                        homeReceiverIdx: item.homeReceiverIdx
                    })
                })
            }
        },
        // CLEAN_AND_ALL_SELECTED(state, payload) {
        //     state.selected = [];
        //     if (!payload.state && !payload.listType) {
        //         state.recipients.forEach(item => {
        //             state.selected.push({
        //                 userIdx: item.userIdx,
        //                 homeSeniorIdx: item.homeSeniorIdx,
        //                 suadeContractIdx: item.suadeContractIdx,
        //                 homeReceiverIdx: item.homeReceiverIdx,
        //             })
        //         })
        //     } else if (payload.state && !payload.listType) {
        //         state.copiedRecipients.forEach(item => {
        //             if (item.suadeContractStateCode === payload.state) {
        //                 state.selected.push({
        //                     userIdx: item.userIdx,
        //                     homeSeniorIdx: item.homeSeniorIdx,
        //                     suadeContractIdx: item.suadeContractIdx,
        //                     homeReceiverIdx: item.homeReceiverIdx,
        //                 })
        //             }
        //         })
        //     }
        // },
        RECIPIENT_SELECTED(state, payload) {
            let index = state.selected.findIndex(item => item.userIdx === payload.userIdx)
            if (index === -1) {
                state.selected.push({
                    userIdx: payload.userIdx,
                    homeSeniorIdx: payload.homeSeniorIdx,
                    suadeContractIdx: payload.suadeContractIdx,
                    homeReceiverIdx: payload.homeReceiverIdx
                })
            } else {
                state.selected.splice(index, 1)
            }
        },
        CAL_RECIPIENT_SELECTED(state, payload) {
            state.calendarIdx = {
                homeReceiverIdx: payload.homeReceiverIdx,
                homeSeniorIdx: payload.homeSeniorIdx
            }
        },
        ABNORMAL_SELECTED(state, payload) {
            state.listType = null
            state.state = null

            state.selected = []
            payload.forEach(item => {
                state.selected.push({
                    userIdx: item.userIdx,
                    homeSeniorIdx: item.homeSeniorIdx,
                    suadeContractIdx: item.suadeContractIdx,
                    homeReceiverIdx: item.homeReceiverIdx
                })
            })
        },
        ALL_SELECTED(state) {
            if (state.copiedRecipients) {
                state.copiedRecipients.forEach(item => {
                    state.selected.push({
                        userIdx: item.userIdx,
                        homeSeniorIdx: item.homeSeniorIdx,
                        suadeContractIdx: item.suadeContractIdx,
                        homeReceiverIdx: item.homeReceiverIdx,
                    })
                })
            }

            return true
        },
        ALL_SELECTED_RECEVING(state) {
            if (state.selected.length > 0) state.selected = []

            state.state = '12'
            state.listType = null
            if (state.recipients) {
                state.recipients.forEach(item => {
                    state.selected.push({
                        userIdx: item.userIdx,
                        homeSeniorIdx: item.homeSeniorIdx,
                        suadeContractIdx: item.suadeContractIdx,
                        homeReceiverIdx: item.homeReceiverIdx,
                    })
                })
            }

            return true
        },
        CONTRACT_SELECTED(state, payload) {
            // if (state.selected.length > 0) state.selected = []

            // state.state = '12'
            // state.listType = null
            if (state.copiedRecipients) {
                state.copiedRecipients.forEach(item => {
                    state.selected.push({
                        userIdx: item.userIdx,
                        homeSeniorIdx: item.homeSeniorIdx,
                        suadeContractIdx: item.suadeContractIdx,
                        homeReceiverIdx: item.homeReceiverIdx,
                    })
                })
            }

            // TODO: 상태만 변경으로 마무리하고 다음에 자동 선택되도록 기능 추가(setTimeout안쓰고 개발)
            // setTimeout(() => {   
            // state.recipients.forEach(item => {
            //     if(item.suadeContractStateCode === state.state) {
            //         state.selected.push({
            //             userIdx: item.userIdx,
            //             homeSeniorIdx: item.homeSeniorIdx,
            //             suadeContractIdx: item.suadeContractIdx,
            //             homeReceiverIdx: item.homeReceiverIdx
            //         })
            //     }
            // })
            // }, 300)
            return true
        },
        REGIST_CHARGE_STAFF(state, payload) {
            state.staffInfo = payload.staffInfo
        },
        DELETE_CHARGE_STAFF(state, payload) {
            let index = state.staffInfo.findIndex(item => item.staffChargeInfoIdx === payload)
            state.staffInfo.splice(index, 1)
            if (!state.staffInfo.length) state.staffInfo = null
            // TODO: 시급제 직원의 경우 담당자에서 빠지게되면 수급자 리스트가 안보여야한다. 체크!
        },
        UPDATE_RECIPIENT_ACTIVE(state, payload) {
            if (payload.data.type === 'active') {
                state.contractInfo.suadeContractStateCode = payload.info.suadeContractInfo.suadeContractStateCode
                state.contractInfo.suadeContractStateCodeName = payload.info.suadeContractInfo.suadeContractStateCodeName
                state.contractInfo.suadeContractPostponeReasonCode = payload.info.suadeContractInfo.suadeContractPostponeReasonCode
                state.contractInfo.suadeContractPostponeReasonCodeName = payload.info.suadeContractInfo.suadeContractPostponeReasonCodeName
                state.contractInfo.contractPostponeReasonMemo = payload.info.suadeContractInfo.contractPostponeReasonMemo

                let index = state.recipients.findIndex(item => item.suadeContractIdx === payload.info.suadeContractInfo.suadeContractIdx)
                if (index !== -1) {
                    state.recipients[index].suadeContractStateCode = payload.info.suadeContractInfo.suadeContractStateCode
                    state.recipients[index].suadeContractStateCodeName = payload.info.suadeContractInfo.suadeContractStateCodeName
                }
            } else if (payload.data.type === 'contract') {
                if (state.recipientContractList) {
                    let arr = payload.info.suadeContractInfo.homeServiceTypeCode === '11' ?
                        state.recipientContractList[payload.data.index].careSuadeContractList :
                        state.recipientContractList[payload.data.index].bathSuadeContractList
                    let index = arr.findIndex(item => item.suadeContractIdx === payload.data.idx && item.suadeContractChangeIdx === payload.data.change)
                    arr[index].suadeContractStateCode = payload.info.suadeContractInfo.suadeContractStateCode
                    arr[index].suadeContractStateCodeName = payload.info.suadeContractInfo.suadeContractStateCodeName
                    arr[index].suadeContractStartYmd = payload.info.suadeContractInfo.suadeContractStartYmd
                    arr[index].suadeContractEndYmd = payload.info.suadeContractInfo.suadeContractEndYmd
                    arr[index].contractStartYmd = payload.info.suadeContractInfo.contractStartYmd
                    arr[index].contractEndYmd = payload.info.suadeContractInfo.contractEndYmd
                }
            }
        },
        UPDATE_RECIPIENT_ACTIVE_ALL(state, payload) {
            let arr = payload.suadeContractIdxs.split(',')
            state.recipients.forEach(item => {
                if (arr.includes(String(item.suadeContractIdx))) {
                    item.suadeContractStateCode = payload.suadeContractStateCode
                    item.suadeContractStateCodeName = payload.suadeContractStateCode === '12' ? '수급중' : '수급보류'
                }
            })
        },
        PERSONAL_CHARGE_HISTORY(state, payload) {
            state.personalChargeHistory = payload.personalChargeHistoryList
        },
        UPDATE_PERSONAL_CHARGE(state, payload) {
            let name = null
            switch (payload.code) {
                case '11':
                    name = '일반15%';
                    break
                case '12':
                    name = '감경9%';
                    break
                case '14':
                    name = '감경6%';
                    break
                case '15':
                    name = '의료6%';
                    break
                case '16':
                    name = '기초생활수급';
                    break
            }
            state.personalChargeHistory = payload.info.personalChargeHistoryList
            state.contractInfo.personalChargeTypeCode = payload.code
            state.contractInfo.personalChargeTypeCodeName = name
        },
        REGIST_ESSENTIAL_FILE(state, payload) {
            if (!state.suadeContractFileList) state.suadeContractFileList = []
            payload.suadeEssentialFile.forEach(item => {

                state.suadeContractFileList.push(item)
            })
        },
        DELETE_ESSENTIAL_FILE(state, payload) {
            let index = state.suadeContractFileList.findIndex(item => item.commonAttachFileIdx === payload.commonAttachFileIdx)
            state.suadeContractFileList.splice(index, 1)
            if (!state.suadeContractFileList.length) state.suadeContractFileList = null
        },
        RECIPIENT_RFID(state, payload) {
            state.salaryOfferLogRfidList = payload.salaryOfferLogRfidList
        },
        RESET_RECIPIENT_RFID(state) {
            state.salaryOfferLogRfidList = null
        },
        RECIPIENT_PERSONAL_COPAY(state, payload) {
            state.personalCopay = payload.personalList
        },
        RECIPIENT_COPAYS_LIST(state, payload) {
            state.personalCopayList = payload.personalList
        },
        RESET_PERSONAL_COPAY(state) {
            state.personalCopay = null
        },
        SALARY_CAREGIVER_LIST(state, payload) { //급여이용제공자 목록 조회
            state.salaryCaregivers = payload
        },
        SALARY_LIST(state, payload) { // 급여이용계획 목록 조회
            state.salarys = payload.salaryOb
        },
        SALARY_ADD_EMPTY_LIST(state) {
            if (!state.salarys) state.salarys = []

            state.salarys.push({
                carUseTypeCode: null,
                caregiverList: null,
                createUserIdx: null,
                createYmdhms: null,
                customerBranchIdx: null,
                dementiaViolenceTendencyYn: 'N',
                endTimeHm: null,
                familyCareRelatCode: null,
                familyCareYn: 'N',
                homeServiceTypeCode: '11',
                older65yearsYn: 'N',
                preSalaryUsePlanIdx: null,
                salaryDayList: [],
                salaryUsePlanIdx: 0,
                serviceWeekDay: [],
                serviceYmd: null,
                startTimeHm: null,
                suadeContractIdx: 0,
                syncFinishYn: null,
                syncYmdhms: null,
                syncerUserIdx: null,
                updateUserIdx: null,
                updateYmdhms: null,
                useYn: null,
                userIdx: null,
                workEndHm: '',
                workStartHm: '',
            })
        },
        SALARY_DELETE_ITEM_LIST(state, payload) { // remove a object index of array
            state.salarys.splice(payload, 1)

            if (!state.salarys.length) state.salarys = null
        },
        ADVANCE_CONTRACT_REG(state, payload) {
            let index = state.recipients.findIndex(item =>
                item.suadeContractIdx === Number(payload.idx)
            )

            // state.recipients[index].suadeContractStateCode = '12'
            // state.recipients[index].suadeContractStateCodeName = '수급중'
            // state.recipients[index].personalChargeTypeCode = payload.code
            // switch(payload.code) {
            //     case '11': state.recipients[index].personalChargeTypeCodeName = '일반15%'; break
            //     case '12': state.recipients[index].personalChargeTypeCodeName = '감경9%'; break
            //     case '14': state.recipients[index].personalChargeTypeCodeName = '감경6%'; break
            //     case '15': state.recipients[index].personalChargeTypeCodeName = '의료6%'; break
            //     case '16': state.recipients[index].personalChargeTypeCodeName = '기초생활수급'; break
            // }
        },
        DELETE_CONTRACT_OVERLAP(state, payload) {
            let index = state.recipients.findIndex(item => item.userIdx === payload)
            state.recipients.splice(index, 1)
            if (!state.recipients.length) state.recipients = null
        },
        DELETE_PERSON_IN_CHARGE(state, payload) {
            state.staffInfo.splice(
                state.staffInfo.findIndex(element => element.staffChargeInfoIdx === payload.idx), 1
            )
        },
        LIST_BASICS_ASSESSMENTS(state, payload) {
            state.assessments =
                (payload.longtermList && payload.longtermList.length > 0) ?
                    payload.longtermList :
                    null

            state.assessmentYear = payload.searchYmd
        },
        UPLOAD_OFFER_PLAN_FILE(state, payload) {
            let obj = state.assessments[payload.index]
            let bIndex = obj.basicEvaluations.findIndex(item => item.ltcareBasisEvaluationIdx === payload.data[0].ltcareBasisEvaluationIdx)
            if (bIndex !== -1) {
                obj.basicEvaluations.splice(bIndex, 1, payload.data[0])
            }
        },
        DELETE_OFFER_PLAN_FILE(state, payload) {
            let obj = state.assessments[payload.pIndex]
            if (payload.homeServiceTypeCode === '11') {
                obj.basicEvaluations[payload.index].careSalaryOfferPlanFileList = null
            } else {
                obj.basicEvaluations[payload.index].bathSalaryOfferPlanFileList = null
            }
        },
        RESET_BASICS_ASSESSMENTS(state, payload) {
            state.assessments = null
        },
        STANDARD_USE_PLAN(state, payload) {
            state.standardUsePlan = payload.list
        },
        RESET_USE_PLAN(state, payload) {
            state.standardUsePlan = null
        },
        STANDARD_USE_CHANGE(state, payload) {
            state.standardUseChange = payload.list
        },
        RESET_CHANGE_PLAN(state, payload) {
            state.standardUseChange = null
        },
        RECIPIENT_PERFORM(state, payload) {
            state.recipientPerform = payload.diaryList
        },
        RESET_RECIPIENT_PERFORM(state, payload) {
            state.recipientPerform = null
        },
        DELETE_CHANGE_PLAN(state, payload) {
            state.standardUseChange[payload.pIndex].standardUseChangeList.splice(payload.cIndex, 1)
            if (!state.standardUseChange[payload.pIndex].standardUseChangeList.length) {
                state.standardUseChange[payload.pIndex].standardUseChangeList = null
            }
        },
        // SERVICE_PROVIDE_PLAN(state, payload) {
        //     state.serviceProvidePlan = payload
        // },
        SERVICE_PROVIDE_PLAN_NEED_AREA(state, payload) {
            state.planNeedAreas = payload.needAreaCodes
        },
        SERVICE_PROVIDE_PLAN_NEED_CONTENT(state, payload) {
            state.planNeedContents = payload
            state.planGroupTargetItems = payload.detailTargetItemList
            state.planSubAreaItems = payload.offerDetailCodeList
        },
        RECIPIENT_CONTRACT_LIST(state, payload) {
            state.recipientContractList = payload.list
        },
        RESET_CONTRACT_LIST(state, payload) {
            state.recipientContractList = null
        },
        RECIPIENT_SERVICE_LOG(state, payload) {
            state.serviceLog = payload.recipientList
        },
        DELETE_SERVICE_LOG(state, payload) {
            let obj = state.serviceLog[payload.pIndex]
            obj.scheduleList[payload.index].serviceOfferReportIdx = 0
            obj.scheduleList[payload.index].staffUserName = null
        },
        RESET_SERVICE_LOG(state, payload) {
            state.serviceLog = null
        },
        DELETE_SERVICE(state, payload) {
            let arr = state.serviceLog[payload.pIndex]
            arr.scheduleList[payload.index].createYmdhms = null
            arr.scheduleList[payload.index].serviceOfferReportNurseIdx = null
            arr.scheduleList[payload.index].createUserName = null
        },
        RECIPIENT_STATE_REPORT(state, payload) {
            state.stateReportList = payload.list
        },
        RESET_STATE_REPORT(state, payload) {
            state.stateReportList = null
        },
        DELETE_STATE_REPORT(state, payload) {
            let arr = state.stateReportList[payload.pIndex]
            arr.scheduleList[payload.index].createYmdhms = null
            arr.scheduleList[payload.index].stateReportIdx = null
            arr.scheduleList[payload.index].createUserName = null
        },
        RECIPIENT_COUNSEL_LIST(state, payload) {
            state.counselList = payload.list
        },
        RESET_COUNSEL_LIST(state, payload) {
            state.counselList = null
        },
        DELETE_COUNSEL(state, payload) {
            let arr = state.counselList[payload.pIndex]
            arr.counselReceiverList[payload.index].staffUserName = null
            arr.counselReceiverList[payload.index].counselReceiverIdx = null
            arr.counselReceiverList[payload.index].targetUserName = null
            arr.counselReceiverList[payload.index].counselYmd = null
        },
        ITEM_USAGE_LIST(state, payload) {
            state.itemUsageList = payload.list
        },
        ITEM_USAGE_DETAIL(state, payload) {
            state.itemUsageLog = payload
            if (state.itemUsageLog.itemUsageLog.itemUsageLogList) {
                state.itemUsageLog.itemUsageLog.itemUsageLogList.forEach(item => {
                    if (item.validPeriodYmd) {
                        item.validPeriodYmd = item.validPeriodYmd.ymdMask()
                    }
                })
            }
        },
        RESET_USAGE_LIST(state, payload) {
            state.itemUsageList = null
        },
        DELETE_ITEM_USAGE(state, payload) {
            let arr = state.itemUsageList[payload.pIndex]
            arr.itemUsageLogList[payload.index].itemUsageLogIdx = null
            arr.itemUsageLogList[payload.index].createYmdhms = null
            arr.itemUsageLogList[payload.index].createUserName = null
        },
        // SELECT_SCHEDULE(state, payload) {
        //     state.tmpSelectSchedule = payload
        // },
        RESET_SELECT_SCHEDULE(state, payload) {
            state.tmpSelectSchedule = null
        },
        MEDICINE_LOG_LIST(state, payload) {
            state.medicineLogList = payload.list
        },
        RESET_MEDICINE_LOG(state, payload) {
            state.medicineLogList = null
        },
        MEDICINE_LOG_DETAIL(state, payload) {
            state.medicineLog = payload
            if (state.medicineLog.medicineManageLog) {
                state.medicineLog.medicineManageLog.forEach(item => {
                    if (item.prescriptYmd) {
                        item.prescriptYmd = item.prescriptYmd.ymdMask()
                    }
                })
            }
        },
        DELETE_MEDICINE_LOG(state, payload) {
            state.medicineLogList[payload.pIndex].medicineLogList.splice(payload.index, 1)
            if (!state.medicineLogList[payload.pIndex].medicineLogList.length) {
                state.medicineLogList[payload.pIndex].medicineLogList = null
            }
        },
        SELECT_COPAY_SUADE(state, payload) {
            state.selectCopaySuadeIdx = payload
        },
        SEARCH_MEDICINE_INFO(state, payload) {
            state.searchMedicine = payload
        },
        SEARCH_HOSPITAL_INFO(state, payload) {
            state.searchHospital = payload
        },
        SYNTHESIS_REPORT(state, payload) {
            state.synthesisList = payload.list
        },
        RESET_SYNTHESIS_REPORT(state, payload) {
            state.synthesisList = null
        },
        DELETE_SYNTHESIS_REPORT(state, payload) {
            let arr = state.synthesisList[payload.pIndex]
            arr.synthesisReportList[payload.index].counselReceiverIdx = null
            arr.synthesisReportList[payload.index].counselReceiverCreateYmdhms = null
            arr.synthesisReportList[payload.index].serviceOfferReportNurseIdx = null
            arr.synthesisReportList[payload.index].serviceOfferReportCreateYmdhms = null
            arr.synthesisReportList[payload.index].stateReportIdx = null
            arr.synthesisReportList[payload.index].stateReportCreateYmdhms = null
            arr.synthesisReportList[payload.index].itemUsageLog = null
        },
        PERSONAL_DEPOSIT(state, payload) {
            let index = state.personalCopay.findIndex(item => item.suadeContractIdx === payload.receiverInfo.suadeContractIdx)
            state.personalCopay.splice(index, 1, payload.receiverInfo)
        },
        PERSONAL_DEPOSIT_LIST(state, payload) {
            console.log(payload)
            if (payload.personalYn === 'N') {
                if (payload.soloYn === 'Y') {
                    state.personalCopayList.splice(payload.index, 1, payload.info.personalInfo)
                } else {
                    state.personalCopayList = payload.info.personalList
                }
            } else {
                if (payload.soloYn === 'Y') {
                    payload.info.personalInfo.depositYmd = payload.info.personalInfo.depositYmd.ymdMask()
                    payload.info.personalInfo.depositAmount = String(payload.info.personalInfo.depositAmount).minusNum()
                    state.aRecipientDeposits.splice(payload.index, 1, payload.info.personalInfo)
                } else {
                    state.aRecipientDeposits = payload.info.personalList
                    if (state.aRecipientDeposits) {
                        state.aRecipientDeposits.forEach(item => {
                            item.depositAmount = String(item.depositAmount).minusNum()
                            item.depositYmd = item.depositYmd.ymdMask()
                        })
                    }
                }
            }
        },
        DELETE_DEPOSIT(state, payload) {
            let index = state.personalCopay.findIndex(item => item.suadeContractIdx === payload.receiverInfo.suadeContractIdx)
            state.personalCopay.splice(index, 1, payload.receiverInfo)
        },
        DELETE_DEPOSIT_INDEX(state, payload) {
            let index = state.aRecipientDeposits.findIndex(item => item.personalChargeDepositHistoryIdx === payload)
            state.aRecipientDeposits.splice(index, 1)
            if (!state.aRecipientDeposits.length) state.aRecipientDeposits = null
        },
        DELETE_DEPOSIT_LIST(state, payload) {
            state.aRecipientDeposits.splice(Number(payload), 1)
            if (!state.aRecipientDeposits.length) state.aRecipientDeposits = null
        },
        ADD_DEPOSIT_LIST(state, payload) {
            if (!state.aRecipientDeposits) state.aRecipientDeposits = []

            state.aRecipientDeposits.push({
                homeReceiverIdx: state.selectedModel.homeReceiverIdx,
                depositYmd: new Date().toISOString().substr(0, 10),
                depositAmount: 0,
                payMethodCode: '12',
                depositorName: state.selectedModel.depositorName,
                depositMemo: null,
                personalChargeSalaryHistoryIdx: 0,
                personalChargeSalaryHistoryIdx: 0,
                seniorName: state.selectedModel.seniorName,
                seniorBirthday: state.selectedModel.seniorBirthday
            })
        },
        ADDING_NON_BENEFIT(state, payload) {
            state.processName = payload.p.mode
            state.selectedModel = payload.p.model

            state.processStatus = true
        },
        PROCESS_COPAY_ON_LIST(state, payload) {
            console.log(payload)
            if (payload.p.mode === 'EachDeposit') {
                state.processName = payload.p.mode
                state.aRecipientDeposits = payload.data.depositList
                if (state.aRecipientDeposits) {
                    state.aRecipientDeposits.forEach(item => {
                        item.depositYmd = item.depositYmd.ymdMask()
                        item.depositAmount = item.depositAmount.amount()
                    })
                }

                state.selectedModel = payload.p.model
            } else {
                state.selectCopaySuadeIdx = payload.p.suadeContractIdx
                state.processPayload = {
                    indexNo: payload.p.index,
                    data: payload.p.model,
                }
                state.processName = payload.p.mode
            }

            state.processStatus = true
        },
        PROCESS_DEPOSIT_BY_ONCE(state, payload) {
            state.idxGroup = payload.idxGroup
            state.processName = payload.mode
            state.processStatus = true
        },
        EXCHANGE_PROCESS_COAPY_STATE(state, payload) {
            state.processStatus = payload.status
            state.processPayload = payload.data
            state.processName = payload.name
        },
        RECIPIENT_RENEWAL(state, payload) {
            state.renewAll = payload
        },
        RECIPIENT_RENEW_INFO(state, payload) {
            state.renewContracts = payload
        },
        RECIPIENT_CONTRACT_CHANGE(state, payload) {
            state.contractChange = payload.suadeContractChangeList
        },
        SUBMIT_FILE_LIST(state, payload) {
            state.submitFileList = payload.rtnList
        },
        RESET_SUBMIT_FILE(state, payload) {
            state.submitFileList = null
        },
        REGIST_NURSE_FILE(state, payload) {
            let index = state.submitFileList.findIndex(item => item.suadeContractIdx === payload.idx)
            state.submitFileList.splice(index, 1, payload.info.rtnList[0])

            // let mm = payload.ymd.substr(4, 2)
            // if(mm.substr(0,1) === '0') {
            //     mm = mm.substr(1,1)
            // }
            // console.log(mm)
            // let arr = state.submitFileList[index].monthList
            // if(!arr[Number(mm)-1].fileList) arr[Number(mm)-1].fileList = []
            // payload.info.suadeEssentialFile.forEach(item => {
            //     arr[Number(mm)-1].fileList.push(item)
            // })
            // arr[Number(mm)-1].issueYmd = payload.ymd
            // state.submitFileList[index].monthList = arr

            // console.log(state.submitFileList[index].monthList)

        },
        ESSENTIAL_FILE_LIST(state, payload) {
            state.eachEssentialFiles = payload.rtnList
        },
        RESET_ESSENTIAL_FILE_LIST(state, payload) {
            state.eachEssentialFiles = null
        },
        DELETE_SELCECTED_FILE_TYPE(state, payload) {
            let index = state.eachEssentialFiles.findIndex(item => item.homeReceiverIdx === payload.hidx)
            if (payload.suadeContractEssentialTypeCode === '12') {
                state.eachEssentialFiles[index].suadeContractList[payload.index].ltcareCertificate = null
            } else if (payload.suadeContractEssentialTypeCode === '11') {
                state.eachEssentialFiles[index].suadeContractList[payload.index].salaryUsePlan = null
            } else {
                state.eachEssentialFiles[index].suadeContractList[payload.index].welfareConfirm = null
            }
        },
        REGIST_SELECT_CONTRACT(state, payload) {
            let index = state.eachEssentialFiles.findIndex(item => item.homeReceiverIdx === payload.all.homeReceiverIdx)
            let pIndex = state.eachEssentialFiles[index].suadeContractList.findIndex(item => item.suadeContractIdx === payload.idx)

            if (payload.type === '11') { //개장기    
                if (!state.eachEssentialFiles[index].suadeContractList[pIndex].salaryUsePlan) {
                    state.eachEssentialFiles[index].suadeContractList[pIndex].salaryUsePlan = []
                }
                payload.info.suadeEssentialFile.forEach(item => {
                    state.eachEssentialFiles[index].suadeContractList[pIndex].salaryUsePlan.push(item)
                })
            } else if (payload.type === '12') { //인정서
                state.eachEssentialFiles[index].suadeContractList[pIndex].ltcareCertificate = payload.info.suadeEssentialFile
            } else if (payload.type === '13') { //복지용구
                state.eachEssentialFiles[index].suadeContractList[pIndex].welfareConfirm = payload.info.suadeEssentialFile
            }
        },
        LATEST_CONTRACT(state, payload) {
            state.latestCare = payload.careSuadeContractInfo
            state.latestBath = payload.bathSuadeContractInfo
        },
        GET_BANK_ACCOUNT_PAGE(state, payload) {
            if (payload.type === '11') {
                state.latestCare.customerBankAccount = payload.info.customerBankAccount
            } else {
                state.latestBath.customerBankAccount = payload.info.customerBankAccount
            }

        },
        DISINFECT_LIST(state, payload) {
            state.disinfectList = payload.recipientList
        },
        RESET_DISINFECT_LIST(state, payload) {
            state.disinfectList = null
        },
        PRICE_CHANGE_NOTICE(state, payload) {
            state.changeNotice = payload.list[0]
        },
        // be added since 2021.12.23
        GET_PERFORMANCES(state, payload) {
            state.performances = payload.rtnList
        },
        GET_PERFORMANCES_COG(state, payload) {
            state.cogPerformances = payload.rtnList
        },
        // 업무수행일지(NEW) 이전기록지 불러오기
        SET_RECIPIENT_DIARY_ALL(state, payload) {
            state.recipientDiaryAll = payload
        },
        DELETE_PERFORMANCE_LOG(state, payload) {
            if (payload.type === 'normal') {
                let arr = state.performances[payload.index]
                let index = arr.performLogList.findIndex(item => item.performLogIdx === payload.pidx)
                arr.performLogList[index].performLogIdx = 0
                arr.performLogList[index].visitYmd = null
                arr.performLogList[index].visitStartYmdhms = null
                arr.performLogList[index].visitEndYmdhms = null
                arr.performLogList[index].writeYmd = null
                arr.performLogList[index].createName = null
            } else {
                let arr = state.cogPerformances[payload.index]
                let index = arr.performLogList.findIndex(item => item.performLogIdx === payload.pidx)
                arr.performLogList[index].performLogIdx = 0
                arr.performLogList[index].visitYmd = null
                arr.performLogList[index].visitStartYmdhms = null
                arr.performLogList[index].visitEndYmdhms = null
                arr.performLogList[index].writeYmd = null
                arr.performLogList[index].createName = null
            }
        },
        RESET_PERFORMANCES(state, payload) {
            state.performances = null
        },
        RESET_COG_PERFORMANCES(state, payload) {
            state.cogPerformances = null
        },
        CAREGIVER_LIST(state, payload) {
            state.caregiverList = payload.caregiverList
        },
        DELETE_CONTRACT(state, payload) {
            let index
            if (payload.type === '11') {
                index = state.recipientContractList[payload.index].careSuadeContractList.findIndex(item =>
                    item.suadeContractIdx === payload.suadeContractIdx && item.suadeContractChangeIdx === payload.idx)
                state.recipientContractList[payload.index].careSuadeContractList.splice(index, 1)
                if (!state.recipientContractList[payload.index].careSuadeContractList.length) state.recipientContractList[payload.index].careSuadeContractList = null
            } else {
                index = state.recipientContractList[payload.index].bathSuadeContractList.findIndex(item =>
                    item.suadeContractIdx === payload.suadeContractIdx && item.suadeContractChangeIdx === payload.idx)
                state.recipientContractList[payload.index].bathSuadeContractList.splice(index, 1)
                if (!state.recipientContractList[payload.index].bathSuadeContractList.length) state.recipientContractList[payload.index].bathSuadeContractList = null
            }

            if (!state.recipientContractList[payload.index].careSuadeContractList //계약서가 하나도 없으면 대기자로 이동되기 때문에 해당 리스트 삭제
                &&
                !state.recipientContractList[payload.index].bathSuadeContractList) {
                let lIndex = state.recipients.findIndex(item => item.homeSeniorIdx === payload.hidx)
                if (lIndex !== -1) {
                    state.recipients.splice(lIndex, 1) //왼쪽 수급자 리스트에서 삭제
                }
                state.recipientContractList.splice(payload.index, 1) //전자계약관리 조회 목록에서 삭제
            }
        },
        STANDARD_CHANGE_PLAN(state, payload) {
            state.salaryNumberCodes = payload.numberCodes
        },
        GET_WORKING_STATUS_PROGRESS(state, payload) {
            state.statusWorkingProgress = payload
        },
        RESET_WORKING_STATUS_PROGRESS(state, payload) {
            state.statusWorkingProgress = null
        },
        STATUS_USING_BETWEEN_PAYMENTS(state, payload) {
            state.statusUsingAmount = payload
        },
        RESET_BETWEEN_PAYMENTS(state, payload) {
            state.statusUsingAmount = null
        },
        STATUS_SUPPORT_ADDITION(state, payload) {
            state.additionSupportAmount = payload.addRecipientList
        },
        RESET_SUPPORT_ADDITION(state, payload) {
            state.additionSupportAmount = null
        },
        DASHBOARD(state, payload) {
            state.dashboard = payload
            state.endContractList = payload.endContractList
            state.gradeCount = payload.gradeCount
            state.ltcareBasisList = payload.ltcareBasisList
            state.abnormalContractList = payload.abnormalContractList
            state.ltcareGradeCount = payload.ltcareGradeCount
            state.newContractRecipientList = payload.contractRecipientList
            state.performLogList = payload.performLogList
            state.periodEndCount = payload.periodEndCount
            state.receiverStateCount = payload.receiverStateCount
            state.recipientCount = payload.recipientCount
            state.rfidTagList = payload.rfidTagList
            state.moveList = payload.moveList
            state.postponeList = payload.postponeList
            state.moveHospitalList = payload.moveHospitalList
            state.deathList = payload.deathList
            state.suadeContract11List = payload.suadeContract11List
        },
        DASHBOARD_PERFORM(state, payload) {
            state.performLogList = payload.performLogList
        },
        DASHBOARD_CONTRACT(state, payload) {
            state.newContractRecipientList = payload.contractRecipientList
        },
        DASHBOARD_RFID(state, payload) {
            state.rfidTagList = payload.rfidTagList
        },
        NOT_MATCH_REPORT(state, payload) {
            state.notMatchReport = payload.list
        },
        UPDATE_MATCH_REPORT(state, payload) {
            let index = state.notMatchReport.findIndex(item => item.reportIdx === payload)
            if (index !== -1) state.notMatchReport.splice(index, 1)
        },
        DELETE_MATCH_REPORT(state, payload) {
            let index = state.notMatchReport.findIndex(item => item.reportIdx === payload)
            if (index !== -1) state.notMatchReport.splice(index, 1)
        },
        GET_PERFORMANCE_PLAN_SCHEDULE(state, payload) {
            state.performPlanList = payload.planList
        },
        OFFER_SERVICE(state, payload) {
            state.offerService = payload.rtnList
        },
        RESET_OFFER_SCHEDULE(state, payload) {
            state.offerService = null
        },
        ERROR_RFID_TAG(state, payload) {
            state.rfidErrorRecipientList = payload.rfidErrorRecipientList
            state.rfidErrorStaffList = payload.rfidErrorStaffList
        },
        RESET_ERROR_RFID_TAG_RECIPIENT(state) {
            state.rfidErrorRecipientList = null
        },
        RESET_ERROR_RFID_TAG_STAFF(state) {
            state.rfidErrorStaffList = null
        },
        RFID_COMPARE_DAY(state, payload) {
            state.rfidCompareDay = payload.scheduleRfidList
        },
        RESET_RECIPIENT_RFID_DAY(state, payload) {
            state.rfidCompareDay = null
        },
        SMS_RECEIVER(state, payload) {
            state.smsReceiver = payload
            if (state.smsReceiver.smsReceiverMobileNo) {
                state.smsReceiver.smsReceiverMobileNo = state.smsReceiver.smsReceiverMobileNo.mobileMask()
            }
        },
        UPDATE_SMS_RECEIVER(state, payload) {
            if (state.smsReceiver) {
                state.smsReceiver.smsReceiverName = payload.smsReceiverName
                state.smsReceiver.smsReceiverMobileNo = payload.smsReceiverMobileNo.mobileMask()
            }
        },
        PERSONAL_CHARGE_LIST(state, payload) {
            state.personalPushList = payload.receiverList
            if (state.personalPushList) {
                state.personalPushList.forEach(item => {
                    Vue.set(item, 'mobileEdit', false)
                    Vue.set(item, 'nameEdit', false)
                })
            }
        },
        DELETE_PERSONAL_LIST(state, payload) {
            state.personalPushList.splice(payload, 1)
        },
        ALL_DELETE_PERSONAL_LIST(state, payload) {
            state.personalPushList = null
        },
        PERSONAL_CHARGE_DEFAULT(state, payload) {
            let arr = []
            if (payload.smsSendPhone) {
                payload.smsSendPhone.forEach(item => {
                    arr.push(item.mobileMask())
                })
            }
            state.smsSendPhone = arr
        },
        ALL_DEPOSIT_LIST(state, payload) {
            state.allDepositList = payload.list
        },
        RESET_ALL_DEPOSIT(state) {
            state.allDepositList = null
        },
        RECIPIENT_DEPOSIT_LIST(state, payload) {
            state.eachDepositList = payload.depositList
            if (state.eachDepositList) {
                state.eachDepositList.forEach(item => {
                    item.depositAmount ? item.depositAmount = item.depositAmount.amount() : null
                    item.depositYmd ? item.depositYmd = item.depositYmd.ymdMask() : null
                })
            }
        },
        RESET_DEPOSIT_LIST(state) {
            state.eachDepositList = null
        },
        ADD_DEPOSIT(state, payload) {
            if (!state.eachDepositList) state.eachDepositList = []

            state.eachDepositList.push({
                homeReceiverIdx: payload.homeReceiverIdx,
                depositYmd: new Date().toISOString().substr(0, 10),
                depositAmount: 0,
                payMethodCode: '12',
                depositorName: payload.depositorName,
                depositMemo: null,
                personalChargeSalaryHistoryIdx: 0,
                personalChargeSalaryHistoryIdx: 0,
                seniorName: payload.seniorName,
                seniorBirthday: payload.seniorBirthday
            })
        },
        DELETE_DEPOSIT_ITEM(state, payload) {
            state.eachDepositList.splice(payload, 1)
            if (!state.eachDepositList.length) state.eachDepositList = null
        },
        DELETE_DEPOSIT_INFO(state, payload) {
            let index = state.eachDepositList.findIndex(item => item.personalChargeDepositHistoryIdx === payload)
            state.eachDepositList.splice(index, 1)
            if (!state.eachDepositList.length) state.eachDepositList = null
        },
        EACH_DEPOSIT(state, payload) {
            if (payload.soloYn === 'Y') {
                payload.info.personalInfo.depositYmd = payload.info.personalInfo.depositYmd.ymdMask()
                payload.info.personalInfo.depositAmount = String(payload.info.personalInfo.depositAmount).minusNum()
                state.eachDepositList.splice(payload.index, 1, payload.info.personalInfo)
            } else {
                state.eachDepositList = payload.info.personalList
                if (state.eachDepositList) {
                    state.eachDepositList.forEach(item => {
                        item.depositAmount = String(item.depositAmount).minusNum()
                        item.depositYmd = item.depositYmd.ymdMask()
                    })
                }
            }
        },
        SCHEDULE_MANAGEMENT(state, payload) {
            state.offerList = payload.offerList
            if (payload.staffList) {
                payload.staffList.forEach(item => {
                    if (item.staffContractCode !== '21' && item.staffContractCode !== '22') {
                        item.salaryNumberList.forEach(salary => {
                            salary['count'] = 0
                        })
                    }
                })
                state.offerStaffList = payload.staffList
            } else {
                state.offerStaffList = null
            }

            state.allScheduleInfo = payload
            state.ltcareMonthUseLimit = payload.ltcareMonthUseLimit
            state.salaryNumberCodes = payload.numberCodes
        },
        DELETE_SCHEDULE(state, payload) {
            state.offerList.splice(payload, 1)
            if (!state.offerList.length) state.offerList = null
        },
        BATCHES_SCHEDULE(state, payload) { //일정 일괄등록(요일별)
            if (!state.offerList) state.offerList = []
            payload.forEach(item => {
                state.offerList.push(item)
            })
        },
        ONE_DAY_SCHEDULE(state, payload) { //선택한 날짜에 일정등록(일별)
            if (!state.offerList) state.offerList = []
            state.offerList.push(payload)
        },
        DELETE_ALL_SCHEDULE(state) { //배정 일괄취소
            state.offerList = null
        },
        STAFF_OTHER_SCHEDULE(state, payload) { //종사자의 현재 선택한 수급자 외 나머지 일정 조회
            state.staffOtherSchedule = payload.offerList
        },
        RESET_OTHER_SCHEDULE(state) { //종사자의 다른 일정 모두 삭제(선택된 급여제공자가 없을때)
            state.staffOtherSchedule = null
        },
        SERVICE_SYNC_ERROR(state, payload) {
            state.ServiceSyncError = payload.syncErrorList
        },
        SET_NUMBERS_TYPE(state, payload) {
            state.numbersType = payload
        },
        ADD_TEMP_STAFF(state, payload) { // 급여제공자를 선택하면 staffList에 추가
            if (!state.offerStaffList) state.offerStaffList = []
            let arr = []
            if (state.offerStaffList.length) {
                state.offerStaffList.forEach(item => {
                    arr.push(item.staffUserIdx)
                })
            }
            payload.forEach(item => {
                if (!arr.includes(item.staffUserIdx)) {
                    item.salaryNumberList.forEach(salary => {
                        salary['count'] = 0
                    })
                    state.offerStaffList.push(item)
                }
            })
        },
        RECIPIENT_SERVICE_PLAN(state, payload) {
            state.servicePlan = payload.salaryOb
        },
        DELETE_A_PERSONAL_CHARGE(state, payload) {
            let findIdx = state.personalChargeHistory.findIndex(element => element.longtermCareGradeChargeHistoryIdx == payload.longtermCareGradeChargeHistoryIdx)
            if (findIdx > -1) state.personalChargeHistory.splice(findIdx, 1)
        },
        RECIPIENT_SIMPLE(state, payload) {
            state.recipientSimple = payload.list
        },
        REGIST_SCHEDULE_MANAGEMENT(state, payload) {
            if (state.recipientSimple) {
                let index = state.recipientSimple.findIndex(item => item.homeReceiverIdx === payload)

                if (index !== -1) {
                    if (state.recipientSimple[index].editScheduleYn !== 'Y') {
                        state.recipientSimple[index].editScheduleYn = 'Y'
                    }
                }
            }
        },
        SET_FAMILY_YN(state, payload) {
            state.familyYn = payload
        },
        CONTRACT_LIST(state, payload) {
            state.contractList = payload.list
        },
        CONTRACT_LIST_CONCAT(state, payload) {
            if (!state.contractList) state.contractList = []
            state.contractList = state.contractList.concat(payload.list)
        },
        RESET_CONTRACT_LIST(state, payload) {
            state.contractList = null
        },
        DELETE_CONTRACT_FILE(state, payload) {
            let pArr = state.contractList[payload.pIndex]
            let arr = pArr.suadeContractList[payload.index]
            if (payload.suadeContractEssentialTypeCode === '11') {
                arr.ess11FileList = []
            } else if (payload.suadeContractEssentialTypeCode === '12') {
                arr.ess12FileList = []
            } else if (payload.suadeContractEssentialTypeCode === '13') {
                arr.ess13FileList = []
            }
        },
        REGIST_CONTRACT_ESSENTIAL(state, payload) {
            let pArr = state.contractList[payload.data.pIndex]
            let arr = pArr.suadeContractList[payload.data.index]
            if (payload.data.suadeContractEssentialTypeCode === '11') {
                arr.ess11FileList = payload.file.suadeEssentialFile
            } else if (payload.data.suadeContractEssentialTypeCode === '12') {
                arr.ess12FileList = payload.file.suadeEssentialFile
            } else if (payload.data.suadeContractEssentialTypeCode === '13') {
                arr.ess13FileList = payload.file.suadeEssentialFile
            }
        },
        NEW_UPDATE_RECIPIENT_ACTIVE(state, payload) {
            let pArr = state.contractList[payload.data.index]
            let arr = pArr.suadeContractList.filter(item => item.suadeContractIdx === payload.data.idx)
            arr.forEach(item => {
                item.suadeContractStateCode = payload.info.suadeContractStateCode
                item.suadeContractStateCodeName = payload.info.suadeContractStateCodeName
                item.contractStartYmd = payload.info.contractStartYmd
                item.contractEndYmd = payload.info.contractEndYmd
            })
        },
        CONTRACT_ACTIVE_STATUS_ALL(state, payload) {
            let arr = state.contractList.filter(item => payload.tmp.includes(item.homeReceiverIdx))
            let name = null
            switch (payload.suadeContractStateCode) {
                case '14': name = '계약해지'; break
                case '16': name = '계약만료'; break
                case '17': name = '계약취소'; break
            }
            arr.forEach(item => {
                item.suadeContractList.forEach(info => {
                    if (payload.scidxs.includes(info.suadeContractIdx)) {
                        info.suadeContractStateCode = payload.suadeContractStateCode
                        info.suadeContractStateCodeName = name
                    }
                })
            })
        },
        NEW_UPDATE_RECIPIENT(state, payload) {
            let arr = state.contractList.filter(item => payload.tmp.includes(item.homeReceiverIdx))
            arr.forEach(item => {
                item.suadeContractList.forEach(info => {
                    if (payload.suadeContractIdxs.includes(info.suadeContractIdx)) {
                        info.suadeContractStateCode = payload.suadeContractStateCode
                        info.suadeContractStateCodeName = payload.suadeContractStateCode === '12' ? '수급중' : '수급보류'
                    }
                })
            })
        },
        CMS_PAYMENT(state, payload) {
            state.cmsMemberList = payload.cmsMemberList
            if (state.cmsMemberList) {
                state.cmsMemberList.forEach(member => {
                    Vue.set(member, 'actualAmount', member.copayAmount ? member.copayAmount.amount() : '')
                    member.paymentDate = member.paymentDate ? member.paymentDate.ymdMask() : ''
                })
            }
            state.cmsPaymentList = payload.cmsPaymentList
        },
        USER_CMS_INFO(state, payload) {
            if (payload.cmsMemberInfo) {
                let index = state.cmsMemberList.findIndex(item => item.homeReceiverIdx === payload.cmsMemberInfo.homeReceiverIdx)

                if (index !== -1) {
                    state.cmsMemberList[index].cmsMemberStateCode = payload.cmsMemberInfo.cmsMemberStateCode
                    state.cmsMemberList[index].cmsMemberStateCodeName = payload.cmsMemberInfo.cmsMemberStateCodeName
                    state.cmsMemberList[index].cmsRegYn = payload.cmsMemberInfo.cmsRegYn
                }
            }
        },
        CMS_PAYMENT_INFO(state, payload) {
            if (payload.cmsPaymentInfo) {
                let index = state.cmsPaymentList.findIndex(item => item.cmsPaymentIdx === payload.cmsPaymentInfo.cmsPaymentIdx)

                if (index !== -1) {
                    state.cmsPaymentList[index].cmsPaymentStateCode = payload.cmsPaymentInfo.cmsPaymentStateCode
                    state.cmsPaymentList[index].cmsPaymentStateCodeName = payload.cmsPaymentInfo.cmsPaymentStateCodeName
                    state.cmsPaymentList[index].fee = payload.cmsPaymentInfo.fee
                    state.cmsPaymentList[index].resultFlag = payload.cmsPaymentInfo.resultFlag
                }
            }
        },
        SERVICE_PLAN(state, payload) {
            state.servicePlanList = payload.planChangeList
        },
        DELETE_SERVICE_PLAN(state, payload) {
            let obj = state.servicePlanList[payload.pIndex]
            obj.salaryOfferPlanChangeList.splice(payload.index, 1)
        },
        RESET_SERVICE_PLAN(state) {
            state.servicePlanList = null
        },
        EMERGENCY_LIST(state, payload) {
            state.emergencyLog = payload.electapDocumentList
        },
        RESET_EMERGENCY_LIST(state, payload) {
            state.emergencyLog = null
        },
        UPDATE_SELECT_SERVICE_TYPE(state, payload) {
            state.contractServiceType = payload
        }
    },
    actions: {
        // @Description 수급자 선택
        ALL_SELECTED({ commit, state }, payload) {
            commit('ALL_SELECTED')
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    console.log("exec all selected by once on dispatch", state.selected.length)
                    resolve()
                }, 1000)
                // if (state.selected.length > 0) {
                //     setTimeout(() => {
                //         console.log("exec all selected by once on dispatch", state.selected.length)
                //         resolve()
                //     }, 1000)
                // } 
                // else {
                //     reject(Error('no using'));
                // }
            })
        },
        ALL_SELECTED_RECEVING({ commit, state }, payload) {
            commit('CONTRACT_SELECTED', payload)

            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    console.log("exec all selected by once on dispatch", state.selected.length)
                    resolve()
                }, 1000)
                // if (state.selected.length > 0) {
                //     setTimeout(() => {
                //         console.log("exec all selected by once on dispatch", state.selected.length)
                //         resolve()
                //     }, 1000)
                // } else {
                //     reject(Error('no using'));
                // }
            })
        },
        // @Description 수급자 조회
        async RECIPIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.recipients(payload)
                console.log('RECIPIENT info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT error', error)
            }
        },
        // @Description 수급자 간편조회(ex 수급자 셀렉트 박스)
        async RECIPIENT_SIMPLE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.simpleList(payload)
                console.log('RECIPIENT_SIMPLE_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_SIMPLE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_SIMPLE_LIST error', error)
            }
        },
        // @Description 수급자 급여일정 조회(ex 일정 셀렉트 박스)
        async RECIPIENT_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.receiverOfferSchedule(payload)
                console.log('RECIPIENT_SCHEDULE info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_SCHEDULE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_SCHEDULE error', error)
            }
        },
        // @Description 수급계약서 조회
        async RECIPIENT_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.contract(payload)
                console.log('RECIPIENT_CONTRACT info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                    commit('RECIPIENT_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_CONTRACT error', error)
            }
        },
        // @Description 수급자 프로필이미지 등록
        async REGIST_RECIPIENT_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.profileFile(payload)
                console.log('REGIST_RECIPIENT_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_RECIPIENT_IMAGE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_RECIPIENT_IMAGE error', error)
            }
        },
        // @Description 수급자 프로필이미지 삭제
        async DELETE_RECIPIENT_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.delete.fileUpload(payload)
                console.log('DELETE_RECIPIENT_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_RECIPIENT_IMAGE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_RECIPIENT_IMAGE error', error)
            }
        },
        // @Description 수급자 상세정보 조회
        async RECIPIENT_DETAIL_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.recipientDetail(payload)
                console.log('RECIPIENT_DETAIL_INFO info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_DETAIL_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_DETAIL_INFO error', error)
            }
        },
        // @Description 수급자 상세정보 수정 
        async UPDATE_RECIPIENT_DETAIL_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.detail(payload)
                console.log('UPDATE_RECIPIENT_DETAIL_INFO info', res)
                if (res.data.status === 201) {
                    commit('UPDATE_RECIPIENT_DETAIL_INFO', res.data.data)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_RECIPIENT_DETAIL_INFO error', error)
            }
        },
        // @Description 수급자 메모 조회
        async RECIPIENT_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.memo(payload)
                console.log('RECIPIENT_MEMO info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_MEMO error', error)
            }
        },
        // @Description 수급자 메모 등록 
        async REGIST_RECIPIENT_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.memo(payload)
                console.log('REGIST_RECIPIENT_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_RECIPIENT_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_RECIPIENT_MEMO error', error)
            }
        },
        // @Description 수급자 메모 수정
        async UPDATE_RECIPIENT_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.post.updateMemo(payload)
                console.log('UPDATE_RECIPIENT_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_RECIPIENT_MEMO', {
                        midx: payload.midx,
                        memo: res.data.data.memo
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_RECIPIENT_MEMO error', error)
            }
        },
        // @Description 수급자 메모 삭제
        async DELETE_RECIPIENT_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await senior.delete.memo(payload)
                console.log('DELETE_RECIPIENT_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_RECIPIENT_MEMO', payload.midx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_RECIPIENT_MEMO error', error)
            }
        },
        // @Description 시니어 첨부파일 삭제
        async DELETE_RECIPIENT_MEMO_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_RECIPIENT_MEMO_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_RECIPIENT_MEMO_FILE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_RECIPIENT_MEMO_FILE error', error)
            }
        },
        // @Description 수급 가계약 완료
        async BEFORE_REG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.beforeReg(payload)
                console.log('BEFORE_REG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BEFORE_REG error', error)
            }
        },
        // @Description 수급계약 필수파일 업로드
        async REGIST_CONTRACT_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.essFilesUpload(payload)
                console.log('REGIST_CONTRACT_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CONTRACT_FILE error', error)
            }
        },
        // @Description 가계약 정보조회(수급자 정보)
        async BEFORE_REG_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.beforeRegInfo(payload)
                console.log('BEFORE_REG_INFO info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BEFORE_REG_INFO error', error)
            }
        },
        // @Description 필수파일 조회(수급계약)
        // async ESSENTIAL_FILE({commit}, payload) {
        //     try {
        //         store.commit('OPEN_LOADING')
        //         res = await recipient.get.essentialFile(payload)
        //         console.log('ESSENTIAL_FILE info', res)
        //         if(res.data.status === 200) {
        //             commit('ESSENTIAL_FILE', res.data.data)
        //         } else {
        //             store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
        //         }
        //         store.commit('CLOSE_LOADING')
        //     } catch(error) {
        //         store.commit('CLOSE_LOADING')
        //         console.error('ESSENTIAL_FILE error', error)
        //     }
        // },
        // @Description 수급계약 중복체크
        async CONTRACT_OVERLAP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.receiverOverlapCheck(payload)
                console.log('CONTRACT_OVERLAP info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CONTRACT_OVERLAP error', error)
            }
        },
        // @Description 수급계약 중복삭제
        async DELETE_CONTRACT_OVERLAP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.receiverOverlapCheck(payload)
                console.log('DELETE_CONTRACT_OVERLAP info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_CONTRACT_OVERLAP', payload.userIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CONTRACT_OVERLAP error', error)
            }
        },
        // @Description 수급본계약 정보조회
        async ADVANCE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.advanceRegister(payload)
                console.log('ADVANCE_CONTRACT info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ADVANCE_CONTRACT error', error)
            }
        },
        // @Description 수급본계약 완료
        async ADVANCE_CONTRACT_REG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.advanceRegister(payload)
                console.log('ADVANCE_CONTRACT_REG info', res)
                if (res.data.status === 201) {
                    commit('ADVANCE_CONTRACT_REG', {
                        idx: payload.idx,
                        code: payload.data.personalChargeTypeCode
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }

                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ADVANCE_CONTRACT_REG error', error)
            }
        },
        // @Description 담당사회복지사 추가
        async REGIST_CHARGE_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeStaff(payload)
                console.log('REGIST_CHARGE_STAFF info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_CHARGE_STAFF', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CHARGE_STAFF error', error)
            }
        },
        // @Description 담당사회복지사 삭제(상세정보 수정페이지에서 사용)
        async DELETE_CHARGE_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.chargeStaff(payload)
                console.log('DELETE_CHARGE_STAFF info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_CHARGE_STAFF', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CHARGE_STAFF error', error)
            }
        },
        // @Description 수급상태 변경(일괄)
        async UPDATE_RECIPIENT_ACTIVE_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeStateAll(payload)
                console.log('UPDATE_RECIPIENT_ACTIVE_ALL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_RECIPIENT_ACTIVE_ALL', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_RECIPIENT_ACTIVE_ALL error', error)
            }
        },
        // @Description 수급상태 변경
        async UPDATE_RECIPIENT_ACTIVE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeState(payload)
                console.log('UPDATE_RECIPIENT_ACTIVE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_RECIPIENT_ACTIVE', {
                        info: res.data.data,
                        data: payload
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_RECIPIENT_ACTIVE error', error)
            }
        },
        // @Description 수급상태 임시변경 위의 코드와 같지만 수급선택 목록 미초기화를 위해서 함수 분리
        async REPLACE_RECIPIENT_ACTIVE_STATUS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeState(payload)
                console.log('REPLACE_RECIPIENT_ACTIVE_STATUS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: '수급상태가 임시로 변경이 되었습니다.', color: 'success' })
                    if (payload.suadeContractStateCode === '13')
                        store.commit('OPEN_SYSTEM_BAR', { message: '좌측 수급자 목록 상단 계약전체보기 또는 수급중 선택 > 수급보류 중인 어르신들만 보실 수 있습니다.', color: 'info' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REPLACE_RECIPIENT_ACTIVE_STATUS error', error)
            }
        },
        // @Description 본인부담금률 변경내역 조회
        async PERSONAL_CHARGE_HISTORY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.personalChargeHistory(payload)
                console.log('PERSONAL_CHARGE_HISTORY info', res)
                if (res.data.status === 200) {
                    commit('PERSONAL_CHARGE_HISTORY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_CHARGE_HISTORY error', error)
            }
        },
        // @Description 본인부담금률 변경
        async UPDATE_PERSONAL_CHARGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.changePersonalCharge(payload)
                console.log('UPDATE_PERSONAL_CHARGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_PERSONAL_CHARGE', {
                        info: res.data.data,
                        code: payload.personalChargeTypeCode
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_PERSONAL_CHARGE error', error)
            }
        },
        // @Description 본인부담금 납부정보 변경
        async UPDATE_PAY_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.payInfo(payload)
                console.log('UPDATE_PAY_INFO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_PAY_INFO error', error)
            }
        },
        // @Description 수급계약시 작성된 급여이용계획의 서비스 제공 가능자 정보 조회
        async SALARY_CAREGIVER_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.salaryCaregiverList(payload)
                console.log("SALARY_CAREGIVER_LIST", res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                    commit('SALARY_CAREGIVER_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SALARY_CAREGIVER_LIST', error)
            }
        },
        // @Description 수급계약시 작성된 급여이용계획
        async SALARY_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.salary(payload)
                console.log("SALARY_LIST: SALARY INFO LIST", res)
                if (res.data.status === 200) {
                    commit('SALARY_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SALARY_LIST', error)
            }
        },
        // @Description 급여이용계획 등록 및 수정 
        async REGIST_SALARY_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.salary(payload)
                console.log("REGIST_SALARY_PLAN", res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SALARY_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SALARY_PLAN', error)
            }
        },
        // @Description 급여이용계획 삭제
        async REMOVE_SALARY_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.salary(payload)
                console.log("REMOVE_SALARY_PLAN", res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SALARY_DELETE_ITEM_LIST', payload.index)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REMOVE_SALARY_PLAN', error)
            }
        },
        // @Description 수급계약 필수파일 업로드(수급자정보 수정페이지)
        async REGIST_ESSENTIAL_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.essFilesUpload(payload)
                console.log('REGIST_ESSENTIAL_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (payload.type && payload.type === 'list') {
                        commit('REGIST_NURSE_FILE', { info: res.data.data, idx: payload.idx, ymd: payload.issueYmd })
                    } else if (payload.type && payload.type === 'essential') {
                        commit('REGIST_SELECT_CONTRACT', { info: res.data.data, all: payload.all, idx: payload.idx, type: payload.suadeContractEssentialTypeCode })
                    } else {
                        commit('REGIST_ESSENTIAL_FILE', res.data.data)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ESSENTIAL_FILE error', error)
            }
        },
        // @Description 수급계약 필수파일 삭제
        async DELETE_ESSENTIAL_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_ESSENTIAL_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_ESSENTIAL_FILE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ESSENTIAL_FILE error', error)
            }
        },
        // @Description 수급자 RFID내역 조회
        async RECIPIENT_RFID({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                if (payload.type === 'card') {
                    res = await recipient.get.rfid(payload)
                } else {
                    res = await recipient.get.rfidLogYm(payload)
                }
                console.log('RECIPIENT_RFID info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_RFID', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_RFID error', error)
            }
        },
        // @Description 수급자 본인부담금 조회 - 카드형
        async RECIPIENT_PERSONAL_COPAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.personal(payload)
                console.log('RECIPIENT_PERSONAL_COPAY info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_PERSONAL_COPAY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_PERSONAL_COPAY error', error)
            }
        },
        // @Description 수급자 본인부담금 조회 - 목록형
        async RECIPIENT_COPAYS_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.personalListLog(payload)
                console.log('RECIPIENT_COPAYS_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_COPAYS_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_COPAYS_LIST error', error)
            }
        },
        // @Description 수급계약서에 수급자 직접 약관동의 및 서명
        async REGIST_RECIPIENT_SIGN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.registerConfirm(payload)
                console.log('REGIST_RECIPIENT_SIGN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: '수급계약 서명이 완료되었습니다. 3초후 페이지가 닫힙니다.',
                        color: 'success',
                        inset: false
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_RECIPIENT_SIGN error', error)
            }
        },
        // @Description 수급 담당자 일괄변경
        async CHANGE_PERSON_IN_CHARGES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeStaffAll(payload)
                console.log('CHANGE_PERSON_IN_CHARGES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: '수급 담당자 일괄변경을 완료하였습니다.',
                        color: 'success',
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_PERSON_IN_CHARGES error', error)
            }
        },
        // @Description 등급신청서 프린트(시니어,수급자 모두사용)
        async RENEWAL_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.renewal(payload)
                console.log('RENEWAL_PRINT info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RENEWAL_PRINT error', error)
            }
        },
        // @Description 수급 담당자 삭제
        async DELETE_PERSON_IN_CHARGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.chargeStaff(payload)
                console.log('DELETE_PERSON_IN_CHARGE info', res)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('DELETE_PERSON_IN_CHARGE', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_PERSON_IN_CHARGE', error)
            }
        },
        // @Description 기초평가 목록 조회
        async LIST_BASICS_ASSESSMENTS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.ltcarebEval(payload)
                console.log('LIST_BASICS_ASSESSMENTS info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('LIST_BASICS_ASSESSMENTS', res.data.data)
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('LIST_BASICS_ASSESSMENTS', error)
            }
        },
        // @Description 급여제공계획서 파일업로드
        async UPLOAD_OFFER_PLAN_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.offerPlanFile(payload)
                console.log('UPLOAD_OFFER_PLAN_FILE info', res)
                if (res.data.status === 201) {
                    commit('UPLOAD_OFFER_PLAN_FILE', {
                        index: payload.index,
                        data: res.data.data.basicEvaluations
                    })
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPLOAD_OFFER_PLAN_FILE', error)
            }
        },
        // @Description 급여제공계획서 파일 삭제
        async DELETE_OFFER_PLAN_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.offerPlanFile(payload)
                console.log('DELETE_OFFER_PLAN_FILE info', res)
                if (res.data.status === 201) {
                    commit('DELETE_OFFER_PLAN_FILE', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_OFFER_PLAN_FILE', error)
            }
        },
        // @Description 개인별장기이용계획서 조회
        async STANDARD_USE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.standardUsePlan(payload)
                console.log('STANDARD_USE_PLAN info', res)
                if (res.data.status === 200) {
                    commit('STANDARD_USE_PLAN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STANDARD_USE_PLAN', error)
            }
        },
        // @Description 개인별장기이용 변경계획서 조회
        async STANDARD_USE_CHANGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.standardUseChange(payload)
                console.log('STANDARD_USE_CHANGE info', res)
                if (res.data.status === 200) {
                    commit('STANDARD_USE_CHANGE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STANDARD_USE_CHANGE', error)
            }
        },
        // @Description 업무수행일지 조회(상담일지)
        async RECIPIENT_PERFORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.diaryList(payload)
                console.log('RECIPIENT_PERFORM info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_PERFORM', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_PERFORM', error)
            }
        },
        // @Description 기초평가(욕창, 낙상, 인지) 조회
        async RECIPIENT_DEFAULT_TEST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.bcdDetails(payload)
                console.log('RECIPIENT_DEFAULT_TEST info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_DEFAULT_TEST', error)
            }
        },
        // @Description 기초평가(욕구) 조회
        async RECIPIENT_NEEDASSESSMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.classAMdetailsCheck(payload)
                console.log('RECIPIENT_NEEDASSESSMENT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_NEEDASSESSMENT', error)
            }
        },
        // @Description 기초평가(욕창, 낙상, 인지) 등록
        async REGIST_DEFAULT_TEST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.classBCDdetails(payload)
                console.log('REGIST_DEFAULT_TEST info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DEFAULT_TEST', error)
            }
        },
        async REGIST_NEEDASSESSMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.classAMdetails(payload)
                console.log('REGIST_NEEDASSESSMENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_NEEDASSESSMENT', error)
            }
        },
        // @Description 인지평가 파일업로드(멀티) 
        async UPLOAD_CIST_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.evalImage(payload)
                console.log('UPLOAD_CIST_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPLOAD_CIST_FILE', error)
            }
        },
        // @Description 인지평가 파일삭제
        async DELETE_CIST_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('UPLOAD_CIST_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPLOAD_CIST_FILE', error)
            }
        },
        // @Description 기초평가(욕창, 낙상, 인지, 욕구) 삭제
        async DELETE_DEFAULT_TEST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.ltcarebEvalDetail(payload)
                console.log('DELETE_DEFAULT_TEST info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_DEFAULT_TEST', error)
            }
        },
        // @Description 기초평가 모두 삭제
        async DELETE_ALL_DEFAULT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.ltcarebEval(payload)
                console.log('DELETE_ALL_DEFAULT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ALL_DEFAULT', error)
            }
        },
        // @Description 개인별장기이용 변경 계획서 조회
        async STANDARD_CHANGE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.standardUseChangePlan(payload)
                console.log('STANDARD_CHANGE_PLAN info', res)
                if (res.data.status === 200) {
                    commit('STANDARD_CHANGE_PLAN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STANDARD_CHANGE_PLAN', error)
            }
        },
        // @Description 개인별장기이용 변경 계획서 저장
        async REGIST_CHANGE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.standardUseChangePlan(payload)
                console.log('REGIST_CHANGE_PLAN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message + ' 2초후 변경계획서 리스트로 이동합니다.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CHANGE_PLAN', error)
            }
        },
        // @Description 개인별장기이용 반영 계획서 삭제
        async DELETE_CHANGE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.standardUseChangePlan(payload)
                console.log('DELETE_CHANGE_PLAN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_CHANGE_PLAN', {
                        pIndex: payload.pIndex,
                        cIndex: payload.cIndex
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CHANGE_PLAN', error)
            }
        },
        // @Description 급여제공계획서 조회
        async SERVICE_PROVIDE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceProvidePlan(payload)
                console.log('SERVICE_PROVIDE_PLAN info', res)
                if (res.data.status === 200) {
                    // commit('SERVICE_PROVIDE_PLAN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_PROVIDE_PLAN', error)
            }
        },
        // @Description 급여제공계획서 필요영역
        async SERVICE_PROVIDE_PLAN_NEED_AREA({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceProvidePlanNeedArea(payload)
                console.log('SERVICE_PROVIDE_PLAN_NEED_AREA info', res)
                if (res.data.status === 200) {
                    commit('SERVICE_PROVIDE_PLAN_NEED_AREA', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_PROVIDE_PLAN_NEED_AREA', error)
            }
        },
        // @Description 급여제공계획서 필요내용
        async SERVICE_PROVIDE_PLAN_NEED_CONTENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceProvidePlanNeedContent(payload)
                console.log('SERVICE_PROVIDE_PLAN_NEED_CONTENT info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                // commit('SERVICE_PROVIDE_PLAN_NEED_CONTENT', res.data.data)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_PROVIDE_PLAN_NEED_CONTENT', error)
            }
        },
        async REGIST_PROVIDE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.offerPlanDetailInfo(payload)
                console.log('REGIST_PROVIDE_PLAN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_PROVIDE_PLAN', error)
            }
        },
        // @Description 수급자 계약리스트
        async RECIPIENT_CONTRACT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.recipientContractList(payload)
                console.log('RECIPIENT_CONTRACT_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_CONTRACT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_CONTRACT_LIST', error)
            }
        },
        // @Description 급여제공기록지 리스트 조회
        async RECIPIENT_SERVICE_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceLogList(payload)
                console.log('RECIPIENT_SERVICE_LOG info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_SERVICE_LOG', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_SERVICE_LOG', error)
            }
        },
        // @Description 급여제공기록지 삭제
        async DELETE_SERVICE_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.serviceLog(payload)
                console.log('DELETE_SERVICE_LOG info', res)
                if (res.data.status === 201) {
                    commit('DELETE_SERVICE_LOG', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SERVICE_LOG', error)
            }
        },
        // @Description 급여제공기록지 상세조회
        async SERVICE_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceLogNurse(payload)
                console.log('SERVICE_DETAIL info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_DETAIL', error)
            }
        },
        // @Description 급여제공기록지 등록/수정
        async REGIST_SERVICE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.serviceLogNurse(payload)
                console.log('REGIST_SERVICE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message + ' 2초뒤 급여제공 리스트로 이동합니다.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SERVICE', error)
            }
        },
        // @Description 급여제공기록지 삭제
        async DELETE_SERVICE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.serviceLogNurse(payload)
                console.log('DELETE_SERVICE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SERVICE', {
                        pIndex: payload.pIndex,
                        index: payload.index
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SERVICE', error)
            }
        },
        // @Description 상태기록지 리스트 조회
        async RECIPIENT_STATE_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.stateReportList(payload)
                console.log('RECIPIENT_STATE_REPORT info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_STATE_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_STATE_REPORT', error)
            }
        },
        // @Description 상담일지 리스트 조회
        async RECIPIENT_COUNSEL_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.counselList(payload)
                console.log('RECIPIENT_COUNSEL_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_COUNSEL_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_COUNSEL_LIST', error)
            }
        },
        // @Description 상담일지 리스트(작성화면)
        async RECIPIENT_COUNSEL_ONE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.counselList(payload)
                console.log('RECIPIENT_COUNSEL_ONE info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_COUNSEL_ONE', error)
            }
        },
        // @Description 상담일지 상세조회
        async COUNSEL_DELTAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.counsel(payload)
                console.log('COUNSEL_DELTAIL info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('COUNSEL_DELTAIL', error)
            }
        },
        // @Description 상담일지 등록/수정
        async REGIST_COUNSEL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.counsel(payload)
                console.log('REGIST_COUNSEL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message + ' 2초뒤 상담일지 리스트로 이동합니다.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_COUNSEL', error)
            }
        },
        // @Description 상담일지 삭제
        async DELETE_COUNSEL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.counsel(payload)
                console.log('DELETE_COUNSEL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_COUNSEL', {
                        pIndex: payload.pIndex,
                        index: payload.index
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_COUNSEL', error)
            }
        },
        // @Description 물품사용일지 리스트 조회
        async ITEM_USAGE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.itemUsageLogList(payload)
                console.log('ITEM_USAGE_LIST info', res)
                if (res.data.status === 200) {
                    commit('ITEM_USAGE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_USAGE_LIST', error)
            }
        },
        // @Description 물품사용일지 상세조회
        async ITEM_USAGE_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.itemUsageLog(payload)
                console.log('ITEM_USAGE_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('ITEM_USAGE_DETAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ITEM_USAGE_DETAIL', error)
            }
        },
        // @Description 물품사용일지 등록/수정
        async REGIST_ITEM_USAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.itemUsageLog(payload)
                console.log('REGIST_ITEM_USAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message + ' 2초뒤 물품사용일지 리스트로 이동합니다.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ITEM_USAGE', error)
            }
        },
        // @Description 물품사용일지 삭제
        async DELETE_ITEM_USAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.itemUsageLog(payload)
                console.log('DELETE_ITEM_USAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (payload.pIndex === 0 || payload.pIndex) {
                        commit('DELETE_ITEM_USAGE', {
                            pIndex: payload.pIndex,
                            index: payload.index
                        })
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ITEM_USAGE', error)
            }
        },
        // @Description 물품사용일지 의약품구매목록 조회
        async MEDICINE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.medicinePurchase(payload)
                console.log('MEDICINE_LIST info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEDICINE_LIST', error)
            }
        },
        // @Description 투약관리일지 조회
        async MEDICINE_LOG_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.medicineLogList(payload)
                console.log('MEDICINE_LOG_LIST info', res)
                if (res.data.status === 200) {
                    commit('MEDICINE_LOG_LIST', res.data.data)
                    // store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEDICINE_LOG_LIST', error)
            }
        },
        // @Description 투약관리일지 상세조회
        async MEDICINE_LOG_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.medicineLogDetail(payload)
                console.log('MEDICINE_LOG_DETAIL info', res)
                if (res.data.status === 200) {
                    commit('MEDICINE_LOG_DETAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MEDICINE_LOG_DETAIL', error)
            }
        },
        // @Description 투약관리일지 저장
        async REGIST_MEDICINE_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.medicineLog(payload)
                console.log('REGIST_MEDICINE_LOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MEDICINE_LOG', error)
            }
        },
        // @Description 투약관리일지 삭제
        async DELETE_MEDICINE_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.medicineLog(payload)
                console.log('DELETE_MEDICINE_LOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (payload.type === 'index') {
                        commit('DELETE_MEDICINE_LOG', {
                            pIndex: payload.pIndex,
                            index: payload.index
                        })
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MEDICINE_LOG', error)
            }
        },
        // @Description 의약품정보 검색
        async SEARCH_MEDICINE_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.medicineInfo(payload)
                console.log('SEARCH_MEDICINE_INFO info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SEARCH_MEDICINE_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SEARCH_MEDICINE_INFO', error)
            }
        },
        // @Description 병의원 검색
        async SEARCH_HOSPITAL_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.get.hospital(payload)
                console.log('SEARCH_HOSPITAL_INFO info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SEARCH_HOSPITAL_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SEARCH_HOSPITAL_INFO', error)
            }
        },
        // @Description 간호업무일지 종합보고서 리스트 조회
        async SYNTHESIS_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.synthesisReportList(payload)
                console.log('SYNTHESIS_REPORT info', res)
                if (res.data.status === 200) {
                    commit('SYNTHESIS_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNTHESIS_REPORT', error)
            }
        },
        // @Description 간호업무일지 종합보고서 저장
        async REGIST_SYNTHESIS_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.synthesisReport(payload)
                console.log('REGIST_SYNTHESIS_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message + '. 2초뒤 종합일지 리스트화면으로 이동합니다.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SYNTHESIS_REPORT', error)
            }
        },
        // @Description 간호업무일지 종합보고서 삭제(모두삭제)
        async DELETE_SYNTHESIS_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.synthesisReport(payload)
                console.log('DELETE_SYNTHESIS_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SYNTHESIS_REPORT', {
                        pIndex: payload.pIndex,
                        index: payload.index
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SYNTHESIS_REPORT', error)
            }
        },
        // @Description 간호업무일지 종합보고서 상태기록지 파일 저장
        async REGIST_CONDITION_FILES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.stateReportFile(payload)
                console.log('REGIST_CONDITION_FILES info', res)
                if (res.data.status === 201) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CONDITION_FILES', error)
            }
        },
        // @Description 우편번호 출력 조회
        async RECIPIENTS_ZIPCODE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.zipcode(payload)
                console.log('RECIPIENTS_ZIPCODE info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENTS_ZIPCODE', error)
            }
        },
        // @Description 입소이용 신청서 및 재가서비스 신청서
        async RECIPIENT_APPLICATION_SUPPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.ipsoPrint(payload)
                console.log('RECIPIENT_APPLICATION_SUPPORT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_APPLICATION_SUPPORT', error)
            }
        },
        // @Description 수가변경안내문 조회
        async PRICE_CHANGE_NOTICE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.changeSalaryNotice(payload)
                console.log('PRICE_CHANGE_NOTICE info', res)
                if (res.data.status === 200) {
                    commit('PRICE_CHANGE_NOTICE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PRICE_CHANGE_NOTICE', error)
            }
        },
        // @Description 본인부담금 입금처리(카드형태)
        async PERSONAL_DEPOSIT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.deposit(payload)
                console.log('PERSONAL_DEPOSIT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('PERSONAL_DEPOSIT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_DEPOSIT', error)
            }
        },
        // @Description 본인부담금 입금처리(엑셀형태)
        async PERSONAL_DEPOSIT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.depositList(payload)
                console.log('PERSONAL_DEPOSIT_LIST info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('PERSONAL_DEPOSIT_LIST', {
                        index: payload.index,
                        soloYn: payload.soloYn,
                        info: res.data.data,
                        personalYn: payload.personalYn
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_DEPOSIT_LIST', error)
            }
        },
        // @Description 본인부담금 입금내역 삭제
        async DELETE_DEPOSIT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.deposit(payload)
                console.log('DELETE_DEPOSIT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (payload.type === 'index') {
                        commit('DELETE_DEPOSIT_INDEX', payload.personalChargeDepositHistoryIdx)
                    } else {
                        commit('DELETE_DEPOSIT', res.data.data)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_DEPOSIT', error)
            }
        },
        async RECIPIENT_OFFER_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.offerSchedule(payload)
                console.log('RECIPIENT_OFFER_SCHEDULE info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_OFFER_SCHEDULE', error)
            }
        },
        // @Description 수급계약 재계약 조회
        async RECIPIENT_RENEWAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.renewalContract(payload)
                console.log('RECIPIENT_RENEWAL info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_RENEWAL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_RENEWAL error', error)
            }
        },
        // @Description 수급계약 재계약
        async REGIST_RECIPIENT_RENEWAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.renewalContract(payload)
                console.log('REGIST_RECIPIENT_RENEWAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_RECIPIENT_RENEWAL', error)
            }
        },
        // @Description 수급계약 갱신정보 조회
        async RECIPIENT_RENEW_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.renewContract(payload)
                console.log('RECIPIENT_RENEW_INFO info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_RENEW_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_RENEW_INFO', error)
            }
        },
        // @Description 수급계약 갱신 
        async RECIPIENT_RENEW_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.renewContract(payload)
                console.log('RECIPIENT_RENEW_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_RENEW_CONTRACT', error)
            }
        },
        // @Description 수급 갱신계약 리스트 조회
        async RECIPIENT_CONTRACT_CHANGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.contractChange(payload)
                console.log('RECIPIENT_CONTRACT_CHANGE info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_CONTRACT_CHANGE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_CONTRACT_CHANGE', error)
            }
        },
        // @Description 명세서 일괄발송
        async PERSONAL_PUSH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.personalPush(payload)
                console.log('PERSONAL_PUSH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    store.commit('SET_REMAIN_INFO', res.data.data.remainInfo)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_PUSH error', error)
            }
        },
        // @Description 명세서 선택발송
        async PERSONAL_PUSH_SELECT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.personalPushSelect(payload)
                console.log('PERSONAL_PUSH_SELECT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    store.commit('SET_REMAIN_INFO', res.data.data.remainInfo)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_PUSH_SELECT error', error)
            }
        },
        // @Description 비급여 청구금액 입금처리하기
        async ADDING_NON_BENEFIT({ commit }, payload) {
            // 본부금 처리 from list
            store.commit('OPEN_LOADING')
            if (payload.mode === 'EachDeposit') {
                try {
                    console.log('ADDING_NON_BENEFIT info', res)
                    if (res.data.status !== 200) {
                        store.commit('OPEN_LOADING')
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                        return
                    }

                    store.commit('CLOSE_LOADING')
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('ADDING_NON_BENEFIT', { p: payload, data: res.data.data })
                    return res.data
                } catch (error) {
                    store.commit('CLOSE_LOADING')
                    console.error('ADDING_NON_BENEFIT error', error)
                }
            } else {
                store.commit('CLOSE_LOADING')
                commit('ADDING_NON_BENEFIT', { p: payload, data: null })
            }
        },
        // @Description 본부금 리스트
        async PROCESS_COPAY_ON_LIST({ commit }, payload) {
            // 본부금 처리 from list
            store.commit('OPEN_LOADING')
            if (payload.mode === 'EachDeposit') {
                try {
                    let res = await recipient.get.depositList({
                        cbidx: store.state.cbidx,
                        luidx: store.state.luidx,
                        homeReceiverIdx: payload.model.homeReceiverIdx,
                        year: (!payload.model.chargeYm) ? payload.model.chargeYm.substr(0, 4) : payload.model.chargeYm.substr(0, 4)
                    })
                    console.log('PROCESS_COPAY_ON_LIST info', res)
                    if (res.data.status !== 200) {
                        store.commit('OPEN_LOADING')
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                        return
                    }

                    store.commit('CLOSE_LOADING')
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('PROCESS_COPAY_ON_LIST', { p: payload, data: res.data.data })
                    return res.data
                } catch (error) {
                    store.commit('CLOSE_LOADING')
                    console.error('PROCESS_COPAY_ON_LIST error', error)
                }
            } else {
                store.commit('CLOSE_LOADING')
                commit('PROCESS_COPAY_ON_LIST', { p: payload, data: null })
            }
        },
        // @Description 방문간호지시서 리스트 조회
        async SUBMIT_FILE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.submitFileList(payload)
                console.log('SUBMIT_FILE_LIST info', res)
                if (res.data.status === 200) {
                    commit('SUBMIT_FILE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_FILE_LIST', error)
            }
        },
        // @Description 필수접수서류 현황 조회
        async ESSENTIAL_FILE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.essentialFileList(payload)
                console.log('ESSENTIAL_FILE_LIST info', res)
                if (res.data.status === 200) {
                    commit('ESSENTIAL_FILE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ESSENTIAL_FILE_LIST', error)
            }
        },
        // @Description 필수접수서류 계약단위 삭제
        async DELETE_SELCECTED_FILE_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.essentialFileType(payload)
                console.log('DELETE_SELCECTED_FILE_TYPE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SELCECTED_FILE_TYPE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SELCECTED_FILE_TYPE', error)
            }
        },
        // @Description 본부금 청구내역서
        async PERSONAL_CHARGE_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.chargeDeposit(payload)
                console.log('PERSONAL_CHARGE_INFO info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1500 })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_CHARGE_INFO', error)
            }
        },
        // @Description 본부금 청구내역서
        async PERSONAL_CHARGE_INFO_ALL({ commit }, payload) {
            try {
                console.log('PERSONAL_CHARGE_INFO_ALL info', payload)
                store.commit('OPEN_LOADING')
                res = await recipient.get.chargeDepositAll(payload)
                console.log('PERSONAL_CHARGE_INFO_ALL info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1500 })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_CHARGE_INFO_ALL', error)
            }
        },
        // @Description 본부금 청구명세서
        async PERSONAL_COST_SUMMARY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.payInfo(payload)
                console.log('PERSONAL_COST_SUMMARY info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_COST_SUMMARY', error)
            }
        },
        // @Description 본부금 납부확인서
        async PERSONAL_DEPOSIT_HISTORY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.depositConfirm(payload)
                console.log('PERSONAL_DEPOSIT_HISTORY info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1500 })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_DEPOSIT_HISTORY', error)
            }
        },
        // @Description 본부금 납부확인서
        async PERSONAL_DEPOSIT_HISTORY_ALL({ commit }, payload) {
            try {
                console.log('PERSONAL_DEPOSIT_HISTORY_ALL info', payload)
                store.commit('OPEN_LOADING')
                res = await recipient.get.depositConfirmAll(payload)
                console.log('PERSONAL_DEPOSIT_HISTORY_ALL info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1500 })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_DEPOSIT_HISTORY_ALL', error)
            }
        },
        // @Description 본부금 수납대장
        async PERSONAL_PAY_LEDGER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.payLedger(payload)
                console.log('PERSONAL_PAY_LEDGER info', res)
                if (res.data.status === 200) {
                    store.commit('SHOW_SHORT_MESSAGE', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_PAY_LEDGER', error)
            }
        },
        // @Description 최신계약 조회(요양, 목욕)
        async LATEST_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.latestContract(payload)
                console.log('LATEST_CONTRACT info', res)
                if (res.data.status === 200) {
                    commit('LATEST_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('LATEST_CONTRACT', error)
            }
        },
        // @Description 욕조소독일지 리스트 조회
        async DISINFECT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.disinfectList(payload)
                console.log('DISINFECT_LIST info', res)
                if (res.data.status === 200) {
                    commit('DISINFECT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DISINFECT_LIST', error)
            }
        },
        // @Description 욕조소독일지 프린트 조회
        async DISINFECT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.carDisinfect(payload)
                console.log('DISINFECT_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DISINFECT_PRINT', error)
            }
        },
        // @Description 상태기록지 프린트 조회
        async CONDITION_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.stateReportPrint(payload)
                console.log('CONDITION_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CONDITION_PRINT', error)
            }
        },
        // @Description 급여제공기록지 요양 프린트 조회
        async SERVICE_CARE_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceLogCarePrint(payload)
                console.log('SERVICE_CARE_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_CARE_PRINT', error)
            }
        },
        // @Description 급여제공기록지 목욕 프린트 조회
        async SERVICE_BATH_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceLogBathPrint(payload)
                console.log('SERVICE_BATH_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_BATH_PRINT', error)
            }
        },
        // @Description 수행일지 상세조회
        async PERFORMANCE_FORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.performLog(payload)
                console.log('PERFORMANCE_FORM info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERFORMANCE_FORM', error)
            }
        },
        async GET_PERFORMANCE_PLAN_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.performPlan(payload)
                console.log('GET_PERFORMANCE_PLAN_SCHEDULE info', res)
                if (res.data.status === 200) {
                    commit('GET_PERFORMANCE_PLAN_SCHEDULE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_PERFORMANCE_PLAN_SCHEDULE', error)
            }
        },
        async PROCESS_DEPOSIT_BY_ONCE({ commit }, payload) {
            commit('PROCESS_DEPOSIT_BY_ONCE', payload)
            console.log("payload: " + JSON.stringify(payload));
        },
        // be added from 2021.12.23
        // @Description 업무수행일지(일반)
        async GET_PERFORMANCES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.performLogList(payload)
                console.log('GET_PERFORMANCES info', res)
                if (res.data.status === 200) {
                    commit('GET_PERFORMANCES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_PERFORMANCES', error)
            }
        },
        // @Description 업무수행일지(NEW) 이전기록지 불러오기 — 한 수급자 기준 전체 기록
        async GET_RECIPIENT_DIARY_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.recipientDiaryAll(payload)
                if (res.data.status === 200) {
                    commit('SET_RECIPIENT_DIARY_ALL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_RECIPIENT_DIARY_ALL error', error)
            }
        },
        // @Description 업무수행일지(인지)
        async GET_PERFORMANCES_COG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.cogPerformLogList(payload)
                console.log('GET_PERFORMANCES_COG info', res)
                if (res.data.status === 200) {
                    commit('GET_PERFORMANCES_COG', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_PERFORMANCES_COG', error)
            }
        },
        // @Description 업무수행일지 등록
        async REGIST_PERFORMANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.registerDiary(payload)
                console.log('REGIST_PERFORMANCES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_PERFORMANCES', error)
            }
        },
        // @Description 업무수행일지 삭제
        async DELETE_PERFORMANCE_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.diary(payload)
                console.log('DELETE_PERFORMANCE_LOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_PERFORMANCE_LOG', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_PERFORMANCE_LOG', error)
            }
        },
        // @Description 요양보호사 목록조회
        async CAREGIVER_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.caregiverList(payload)
                console.log('CAREGIVER_LIST info', res)
                if (res.data.status === 200) {
                    commit('CAREGIVER_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CAREGIVER_LIST', error)
            }
        },
        // @Description 수급계약 삭제(계약중, 계약취소 상태일때만 삭제가능)
        async DELETE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.contractChange(payload)
                console.log('DELETE_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_CONTRACT', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CONTRACT', error)
            }
        },
        // @Description 수급자의 업무진행전체현황
        async GET_WORKING_STATUS_PROGRESS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.workProgress(payload)
                console.log('GET_WORKING_STATUS_PROGRESS info', res)
                if (res.data.status === 200) {
                    commit('GET_WORKING_STATUS_PROGRESS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_WORKING_STATUS_PROGRESS', error)
            }
        },
        // @Description 수급자의 사용금액전체현황
        async STATUS_USING_BETWEEN_PAYMENTS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.useAmount(payload)
                console.log('STATUS_USING_BETWEEN_PAYMENTS info', res)
                if (res.data.status === 200) {
                    commit('STATUS_USING_BETWEEN_PAYMENTS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STATUS_USING_BETWEEN_PAYMENTS', error)
            }
        },
        // @Description 수급자 가산금액현황조회
        async STATUS_SUPPORT_ADDITION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.additionAmount(payload)
                console.log('STATUS_SUPPORT_ADDITION info', res)
                if (res.data.status === 200) {
                    commit('STATUS_SUPPORT_ADDITION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STATUS_SUPPORT_ADDITION', error)
            }
        },
        // @Description 우편물발송대장 조회
        async SEND_POST_MGMT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.mailingLedger(payload)
                console.log('SEND_POST_MGMT info', res)
                if (res.data.status === 200) {
                    //    commit('SEND_POST_MGMT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SEND_POST_MGMT', error)
            }
        },
        // @Description 우편물발송대장 저장
        async REGIST_POST_MGMT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.mailingLedger(payload)
                console.log('REGIST_POST_MGMT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_POST_MGMT', error)
            }
        },
        // @Description 우편물발송대장 파일 저장
        async REGIST_POST_MGMT_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.mailingLedgerFile(payload)
                console.log('REGIST_POST_MGMT_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    //    commit('SEND_POST_MGMT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_POST_MGMT_FILE', error)
            }
        },
        // @Description 우편물발송대장 대상자 삭제
        async DELETE_POST_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.mailingLedgerLog(payload)
                console.log('DELETE_POST_LOG info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    //    commit('SEND_POST_MGMT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_POST_LOG', error)
            }
        },
        // @Description 우편물발송대장 파일 삭제
        async DELETE_POST_MGMT_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_POST_MGMT_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_POST_MGMT_FILE', error)
            }
        },
        // @Description 급여제공기록지 확인대장 조회
        async SERVICE_OFFER_LEDGER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceOfferLedger(payload)
                console.log('SERVICE_OFFER_LEDGER info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_OFFER_LEDGER', error)
            }
        },
        // @Description 급여제공기록지 확인대장 푸시
        async SERVICE_OFFER_SIGN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.serviceOfferSign(payload)
                console.log('SERVICE_OFFER_PUSH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_OFFER_PUSH', error)
            }
        },
        // @Description 급여제공기록지 확인대장 서명삭제
        async DELETE_SERVICE_OFFER_SIGN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.serviceOfferLedger(payload)
                console.log('DELETE_SERVICE_OFFER_SIGN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SERVICE_OFFER_SIGN', error)
            }
        },
        // @Description 급여제공기록지 확인대장 프린트
        async SERVICE_OFFER_LEDGER_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.serviceLedgerPrint(payload)
                console.log('SERVICE_OFFER_LEDGER_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_OFFER_LEDGER_PRINT', error)
            }
        },
        // @Description 수급자 대시보드
        async DASHBOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.dash(payload)
                console.log('DASHBOARD info', res)
                if (res.data.status === 200) {
                    commit('DASHBOARD', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD', error)
            }
        },
        // @Url 대시보드 업무수행현황 월별 조회
        async DASHBOARD_PERFORM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.dashPerform(payload)
                console.log('DASHBOARD_PERFORM info', res)
                if (res.data.status === 200) {
                    commit('DASHBOARD_PERFORM', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_PERFORM', error)
            }
        },
        // @Url 대시보드 신규계약자현황 월별 조회
        async DASHBOARD_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.dashSuadeContract(payload)
                console.log('DASHBOARD_CONTRACT info', res)
                if (res.data.status === 200) {
                    commit('DASHBOARD_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_CONTRACT', error)
            }
        },
        // @Url 대시보드 RFID태그사용비율 년도별 조회
        async DASHBOARD_RFID({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.dashRfidTagUse(payload)
                console.log('DASHBOARD_RFID info', res)
                if (res.data.status === 200) {
                    commit('DASHBOARD_RFID', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_RFID', error)
            }
        },
        // @Description 수급자 일정불일치기록지 목록
        async NOT_MATCH_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.adjustReportSchedule(payload)
                console.log('NOT_MATCH_REPORT info', res)
                if (res.data.status === 200) {
                    commit('NOT_MATCH_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NOT_MATCH_REPORT', error)
            }
        },
        // @Description 수급자 일정불일치기록지 일정 재지정
        async UPDATE_MATCH_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.adjustReportSchedule(payload)
                console.log('UPDATE_MATCH_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_MATCH_REPORT', payload.reportIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_MATCH_REPORT', error)
            }
        },
        // @Description 수급자 일정불일치기록지 일정 삭제
        async DELETE_MATCH_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.adjustReportSchedule(payload)
                console.log('DELETE_MATCH_REPORT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MATCH_REPORT', payload.reportIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MATCH_REPORT', error)
            }
        },
        // @Description 수급자 급여제공계획서 실시간 동기화 요청
        async OFFER_PLAN_PUSH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.offerPlanPush(payload)
                console.log('OFFER_PLAN_PUSH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('OFFER_PLAN_PUSH', error)
            }
        },
        // @Description 급여종류내용변경 사실확인서
        async PRINT_CHANGE_SERVICE_CONTENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.changeTypeConfirm(payload)
                console.log('PRINT_CHANGE_SERVICE_CONTENT info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PRINT_CHANGE_SERVICE_CONTENT', error)
            }
        },
        // @Description 수급자격확인 사실확인서
        async PRINT_QUALIFY_CHECK_REQUEST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.qualifyCheckRequest(payload)
                console.log('PRINT_QUALIFY_CHECK_REQUEST info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PRINT_QUALIFY_CHECK_REQUEST', error)
            }
        },
        // @Description 본인부담금 감경신청서
        async PRINT_REDUCE_REQUEST_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.personalReduceApply(payload)
                console.log('PRINT_REDUCE_REQUEST_APPLY info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PRINT_REDUCE_REQUEST_APPLY', error)
            }
        },
        // @Description 수취대리인 위임장: 큰 변경내용이 없어서 상단의 사실확인서 api로 함께 사용
        async PRINT_RECEIVER_POA_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.changeTypeConfirm(payload)
                console.log('PRINT_RECEIVER_POA_APPLY info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PRINT_RECEIVER_POA_APPLY', error)
            }
        },
        // @Description 청구상세내역동기화
        async SYNC_BILLING_DETAILS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.syncOfferSchedule(payload)
                console.log('SYNC_BILLING_DETAILS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: '서비스일정 동기화를 요청했습니다. 1~3분 후 확인해주세요.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNC_BILLING_DETAILS', error)
            }
        },
        // @Description 서비스일정동기화
        async SYNC_OFFER_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.syncOfferSchedule(payload)
                console.log('SYNC_OFFER_SCHEDULE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: '서비스일정 동기화를 요청했습니다. 1~3분 후 확인해주세요.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNC_OFFER_SCHEDULE', error)
            }
        },
        // @Description 급여제공일정(RFID메뉴에서 조회)
        async OFFER_SERVICE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.monthSchedule(payload)
                console.log('OFFER_SERVICE info', res)
                if (res.data.status === 200) {
                    commit('OFFER_SERVICE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('OFFER_SERVICE', error)
            }
        },
        // @Description 본부금 비급여금액 조회
        async PERSONAL_NON_PAYMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.nonPayment(payload)
                console.log('PERSONAL_NON_PAYMENT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_NON_PAYMENT', error)
            }
        },
        // @Description 본부금 비급여금액 등록
        async REGIST_NON_PAYMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.nonPayment(payload)
                console.log('REGIST_NON_PAYMENT info', res)
                if (res.data.status === 201) {
                    store.commit('SHOW_SUB_MESSAGE', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('SHOW_SUB_MESSAGE', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_NON_PAYMENT', error)
            }
        },
        // @Description 본부금 비급여금액 삭제
        async DELETE_NON_PAYMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.nonPayment(payload)
                console.log('DELETE_NON_PAYMENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_NON_PAYMENT', error)
            }
        },
        // @Description 본인부담금 청구내역 상세 삭제 (본인부담금 상세 → 롱텀 청구내역 순차 호출)
        async DELETE_PERSONAL_CHARGE_CLAIM_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                // 1) 본인부담금 청구내역 상세 삭제
                res = await recipient.delete.personalChargeClaimDetail(payload)
                console.log('DELETE_PERSONAL_CHARGE_CLAIM_DETAIL info', res)
                if (res.data.status === 201) {
                    // 2) 롱텀 청구내역 삭제
                    let res2 = await recipient.post.deleteLtcareClaimData({
                        cbidx: payload.cbidx,
                        luidx: payload.luidx,
                        salaryYm: payload.serviceYm
                    })
                    console.log('DELETE_LTCARE_CLAIM_DATA info', res2)
                    if (res2.data.status === 200) {
                        store.commit('OPEN_SYSTEM_BAR', { message: res2.data.message, color: 'success' })
                    } else {
                        store.commit('OPEN_SYSTEM_BAR', { message: res2.data.message, color: 'error' })
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_PERSONAL_CHARGE_CLAIM_DETAIL error', error)
            }
        },


        // @Description 새로운 수급계약 조회 API
        async NEW_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.contractOnce(payload)
                console.log('NEW_CONTRACT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1500 })
                    // commit('NEW_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NEW_CONTRACT', error)
            }
        },
        // @Description 새로운 수급계약 저장 API
        async REGIST_NEW_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.contractOnce(payload)
                console.log('REGIST_NEW_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1000 })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_NEW_CONTRACT', error)
            }
        },
        // @Description 추가정보 등록 API(최초 본계약일떄)
        async REGIST_ADD_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.contractOnceAdd(payload)
                console.log('REGIST_ADD_INFO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1000 })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ADD_INFO', error)
            }
        },
        // @Description 새로운 갱신계약 조회 API
        async NEW_RATE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.contractRenewOnce(payload)
                console.log('NEW_RATE_CONTRACT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1000 })
                    // commit('NEW_RATE_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NEW_RATE_CONTRACT', error)
            }
        },
        // @Description 새로운 재계약 조회 API
        async NEW_RENEW_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.contractRenewalOnce(payload)
                console.log('NEW_RENEW_CONTRACT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', duration: 1000 })
                    // commit('NEW_RENEW_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NEW_RENEW_CONTRACT', error)
            }
        },
        // @Description 수급계약서의 기관계좌번호 조회(계약서)
        async GET_BANK_ACCOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.bankAccount(payload)
                console.log('GET_BANK_ACCOUNT info', res)
                if (res.data.status === 200) {
                    // commit('GET_BANK_ACCOUNT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_BANK_ACCOUNT', error)
            }
        },
        // @Description 수급계약서의 기관계좌번호 조회(수급자 상세보기화면)
        async GET_BANK_ACCOUNT_PAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.bankAccount(payload)
                console.log('GET_BANK_ACCOUNT_PAGE info', res)
                if (res.data.status === 200) {
                    commit('GET_BANK_ACCOUNT_PAGE', {
                        info: res.data.data,
                        type: payload.homeServiceTypeCode
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_BANK_ACCOUNT_PAGE', error)
            }
        },
        // @Description 새로운 갱신계약 저장 API
        async REGIST_NEW_RATE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.contractRenewOnce(payload)
                console.log('REGIST_NEW_RATE_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_NEW_RATE_CONTRACT', error)
            }
        },
        // @Description RFID태그 비정상 내역 조회(수급자기준, 요양보호사 기준)
        async ERROR_RFID_TAG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.errorLog(payload)
                console.log('ERROR_RFID_TAG info', res)
                if (res.data.status === 200) {
                    commit('ERROR_RFID_TAG', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ERROR_RFID_TAG', error)
            }
        },
        // @Description RFID태그내역 비교 조회
        async RFID_COMPARE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.planCompare(payload)
                console.log('RFID_COMPARE info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RFID_COMPARE', error)
            }
        },
        // @Description RFID태그내역 일일 비교
        async RFID_COMPARE_DAY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.planCompareDay(payload)
                console.log('RFID_COMPARE_DAY info', res)
                if (res.data.status === 200) {
                    commit('RFID_COMPARE_DAY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RFID_COMPARE_DAY', error)
            }
        },
        // @Description SMS수신자 조회
        async SMS_RECEIVER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.smsInfo(payload)
                console.log('SMS_RECEIVER info', res)
                if (res.data.status === 200) {
                    commit('SMS_RECEIVER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SMS_RECEIVER', error)
            }
        },
        // @Description 일정일괄발송 — 다건 수급자 정보 일괄 조회
        async SCHEDULE_PUSH_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.schedulePushInfo(payload)
                if (res.data.status === 200) {
                    // 데이터는 컴포넌트에서 응답값으로 처리 — 별도 mutation 없음
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SCHEDULE_PUSH_INFO', error)
            }
        },
        // @Description SMS수신자 변경
        async UPDATE_SMS_RECEIVER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.smsInfo(payload)
                console.log('UPDATE_SMS_RECEIVER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_SMS_RECEIVER', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_SMS_RECEIVER', error)
            }
        },
        // @Description 본부금 문자발송 리스트 조회
        async PERSONAL_CHARGE_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.newPersonalPush(payload)
                console.log('PERSONAL_CHARGE_LIST info', res)
                if (res.data.status === 200) {
                    commit('PERSONAL_CHARGE_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_CHARGE_LIST', error)
            }
        },
        // @Description 본부금 문자발송
        async PERSONAL_CHARGE_PUSH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.newPersonalPush(payload)
                console.log('PERSONAL_CHARGE_PUSH info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_CHARGE_PUSH', error)
            }
        },
        // @Description 본부금 문자발송 기본정보 조회
        async PERSONAL_CHARGE_DEFAULT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.preSmsInfo(payload)
                console.log('PERSONAL_CHARGE_DEFAULT info', res)
                if (res.data.status === 200) {
                    commit('PERSONAL_CHARGE_DEFAULT', res.data.data)
                    store.commit('SET_REMAIN_INFO', res.data.data.remainInfo)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PERSONAL_CHARGE_DEFAULT', error)
            }
        },
        // @Description 수급자 입금내역전체보기
        async ALL_DEPOSIT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.depositListAll(payload)
                console.log('ALL_DEPOSIT_LIST info', res)
                if (res.data.status === 200) {
                    commit('ALL_DEPOSIT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ALL_DEPOSIT_LIST', error)
            }
        },
        // @Description 수급자 본부금 납부리스트
        async RECIPIENT_DEPOSIT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.depositList(payload)
                console.log('RECIPIENT_DEPOSIT_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_DEPOSIT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_DEPOSIT_LIST', error)
            }
        },
        // @Description 본인부담금 입금내역 삭제(입금내역전체보기)
        async DELETE_DEPOSIT_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.deposit(payload)
                console.log('DELETE_DEPOSIT_INFO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (payload.type === 'index') {
                        commit('DELETE_DEPOSIT_INFO', payload.personalChargeDepositHistoryIdx)
                    } else {
                        commit('DELETE_DEPOSIT_INFO', res.data.data)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_DEPOSIT_INFO', error)
            }
        },
        // @Description 본인부담금 개별 입금처리(입금내역전체보기)
        async EACH_DEPOSIT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.depositList(payload)
                console.log('EACH_DEPOSIT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('EACH_DEPOSIT', {
                        index: payload.index,
                        soloYn: payload.soloYn,
                        info: res.data.data,
                        personalYn: payload.personalYn
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EACH_DEPOSIT', error)
            }
        },
        // @Description 수급자 본부금 납부리스트
        async RECIPIENT_DEPOSIT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.depositList(payload)
                console.log('RECIPIENT_DEPOSIT_LIST info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_DEPOSIT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_DEPOSIT_LIST', error)
            }
        },
        // @Description 급여일정관리 캘린더 조회
        async SCHEDULE_MANAGEMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.scheduleManagement(payload)
                console.log('SCHEDULE_MANAGEMENT info', res)
                if (res.data.status === 200) {
                    commit('SCHEDULE_MANAGEMENT', res.data.data)
                    if (res.data.data.staffList) {
                        commit('SET_TMP_STAFF', res.data.data.staffList)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SCHEDULE_MANAGEMENT', error)
            }
        },
        // @Description 급여일정관리 캘린더 임시저장
        async REGIST_SCHEDULE_MANAGEMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.scheduleManagement(payload)
                console.log('REGIST_SCHEDULE_MANAGEMENT info', res)
                if (res.data.status === 201) {
                    if (payload.doType === 'adds') {
                        store.commit('OPEN_SYSTEM_BAR', {
                            message: `
                        총 ${Number(res.data.data.addCount) + Number(res.data.data.omitCount)}건 중 ${res.data.data.addCount}건 확정했습니다. 
                        수급자가 계약(요양,목욕)한 일정만 확정가능합니다. 확정되지 않은 일정이 있다면 수급계약을 확인해주세요.`
                            , color: 'success'
                        })
                    } else {
                        store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    }
                    if (payload.homeReceiverIdx && payload.homeReceiverIdx !== '0') {
                        commit('REGIST_SCHEDULE_MANAGEMENT', payload.homeReceiverIdx)
                    } else {
                        store.commit('senior/REGIST_SCHEDULE_MANAGEMENT', payload.homeSeniorIdx)
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SCHEDULE_MANAGEMENT', error)
            }
        },
        // @Description 종사자의 현재 선택한 수급자 외 나머지 일정 조회
        async STAFF_OTHER_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.scheduleSbidxButidx(payload)
                console.log('STAFF_OTHER_SCHEDULE info', res)
                if (res.data.status === 200) {
                    commit('STAFF_OTHER_SCHEDULE', res.data.data)
                    commit('ADD_TEMP_STAFF', res.data.data.staffList)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_OTHER_SCHEDULE', error)
            }
        },
        // @Description 일정동기화 오류내역 조회
        async SERVICE_SYNC_ERROR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.ServiceErrorLog(payload)
                console.log('SERVICE_SYNC_ERROR info', res)
                if (res.data.status === 200) {
                    commit('SERVICE_SYNC_ERROR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_SYNC_ERROR', error)
            }
        },
        // @Description 청구내역 재동기화
        async RE_SYNC_CLAIM_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await sync.post.reSyncClaimDetail(payload)
                console.log('RE_SYNC_CLAIM_DETAIL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    // commit('RE_SYNC_CLAIM_DETAIL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RE_SYNC_CLAIM_DETAIL', error)
            }
        },
        // @Description 수급자 급여계획일정 조회
        async RECIPIENT_SERVICE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.scheduleManagementSalary(payload)
                console.log('RECIPIENT_SERVICE_PLAN info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_SERVICE_PLAN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_SERVICE_PLAN', error)
            }
        },
        // @Description 승인금액 변경
        async CHANGE_APPROVE_LIMITED_AMOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.approvalAmount(payload)
                console.log('CHANGE_APPROVE_LIMITED_AMOUNT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_APPROVE_LIMITED_AMOUNT', error)
            }
        },
        // @Description 본인부담금률 히스토리 삭제
        async DELETE_A_PERSONAL_CHARGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.personalChargeHistory(payload)
                console.log('DELETE_A_PERSONAL_CHARGE info', res)
                if (res.data.status === 201) {
                    commit('DELETE_A_PERSONAL_CHARGE', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_A_PERSONAL_CHARGE', error)
            }
        },
        // @Description 수급자 서명삭제
        async DELETE_AN_RECIPIENT_PERFORM_SIGNED({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.commonSign(payload)
                console.log('DELETE_AN_RECIPIENT_PERFORM_SIGNED info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_AN_RECIPIENT_PERFORM_SIGNED', error)
            }
        },
        // @Description 급여제공자 서명삭제(업무수행일지)
        async DELETE_AN_STAFF_SIGNED({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.commonSign(payload)
                console.log('DELETE_AN_STAFF_SIGNED info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_AN_STAFF_SIGNED', error)
            }
        },
        // @Description 마지막 욕구사정기록지 불러오기
        async GET_LAST_NEEDS_ASSESSMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.classAMdetailsBefore(payload)
                console.log('GET_LAST_NEEDS_ASSESSMENT info', res)
                if (res.data.status === 200) {
                    // commit('GET_LAST_NEEDS_ASSESSMENT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_LAST_NEEDS_ASSESSMENT', error)
            }
        },
        // @Description 마지막 욕창,낙상,인지평가 불러오기
        async GET_LAST_ASSESSMENTS_TOOLS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.classBcdDetailsBefore(payload)
                console.log('GET_LAST_ASSESSMENTS_TOOLS info', res)
                if (res.data.status === 200) {
                    // commit('GET_LAST_ASSESSMENTS_TOOLS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_LAST_ASSESSMENTS_TOOLS', error)
            }
        },
        // @Description 재무회계 입금내역 삭제하기
        async DELETE_DEPOSIT_FROM_BANK({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.deposit(payload)
                console.log('DELETE_DEPOSIT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_DEPOSIT', error)
            }
        },
        // @Description 수급자리스트(캘린더용)
        async RECIPIENT_SIMPLE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.recipientSmple(payload)
                console.log('RECIPIENT_SIMPLE info', res)
                if (res.data.status === 200) {
                    commit('RECIPIENT_SIMPLE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RECIPIENT_SIMPLE', error)
            }
        },
        // @Description 수급자 상태변화기록지 파일업로드
        async STATE_REPORT_UPLOAD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.stateReport(payload)
                console.log('STATE_REPORT_UPLOAD info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STATE_REPORT_UPLOAD', error)
            }
        },
        // @Description 기초평가 급여제공계획서 삭제
        async DELETE_SALARY_OFFER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.salaryOfferPlan(payload)
                console.log('DELETE_SALARY_OFFER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SALARY_OFFER', error)
            }
        },
        // @Description 신규 수급계약서 리스트 조회
        async CONTRACT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.suadeContractList(payload)
                console.log('CONTRACT_LIST info', res)
                if (res.data.status === 200) {
                    commit('CONTRACT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CONTRACT_LIST', error)
            }
        },
        async CONTRACT_LIST_CONCAT({ commit }, payload) {
            try {
                res = await recipient.get.suadeContractList(payload)
                console.log('CONTRACT_LIST_CONCAT info', res)
                if (res.data.status === 200) {
                    commit('CONTRACT_LIST_CONCAT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
            } catch (error) {
                console.error('CONTRACT_LIST_CONCAT', error)
            }
        },
        // @Description 신규 수급계약서 리스트의 필수서류 삭제
        async DELETE_CONTRACT_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.essentialFileType(payload)
                console.log('DELETE_CONTRACT_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_CONTRACT_FILE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CONTRACT_FILE', error)
            }
        },
        // @Description 신규 수급계약서 리스트의 필수서류 업로드
        async REGIST_CONTRACT_ESSENTIAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.essFilesUpload(payload)
                console.log('REGIST_CONTRACT_ESSENTIAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_CONTRACT_ESSENTIAL', {
                        file: res.data.data,
                        data: payload
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CONTRACT_ESSENTIAL error', error)
            }
        },
        // @Description 신규 수급계약서 상태변경 (선택)
        async NEW_UPDATE_RECIPIENT_ACTIVE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeState(payload)
                console.log('NEW_UPDATE_RECIPIENT_ACTIVE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('NEW_UPDATE_RECIPIENT_ACTIVE', {
                        info: res.data.data.suadeContractInfo,
                        data: payload
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NEW_UPDATE_RECIPIENT_ACTIVE error', error)
            }
        },
        // @Description 수급상태 일괄변경(해지,만료,취소)
        async CONTRACT_ACTIVE_STATUS_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeStateChange(payload)
                console.log('CONTRACT_ACTIVE_STATUS_ALL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CONTRACT_ACTIVE_STATUS_ALL', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CONTRACT_ACTIVE_STATUS_ALL error', error)
            }
        },
        // @Description 희망이음,롱텀 등록,동기화
        async SYNC_MINISTRY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.syncMinistry(payload)
                console.log('SYNC_MINISTRY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNC_MINISTRY error', error)
            }
        },
        // @Description 수급계약 일괄삭제
        async DELETE_CONTRACT_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.contractChanges(payload)
                console.log('DELETE_CONTRACT_ALL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CONTRACT_ALL', error)
            }
        },
        // @Description 수급중, 수급보류 일정변경
        async NEW_UPDATE_RECIPIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.chargeStateAll(payload)
                console.log('NEW_UPDATE_RECIPIENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('NEW_UPDATE_RECIPIENT', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NEW_UPDATE_RECIPIENT', error)
            }
        },
        // @Description CMS리스트 조회
        async CMS_PAYMENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.cmsPayment(payload)
                console.log('CMS_PAYMENT info', res)
                if (res.data.status === 200) {
                    commit('CMS_PAYMENT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CMS_PAYMENT', error)
            }
        },
        // @Description CMS등록을 위한 수급자정보 조회
        async USER_CMS_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.cmsMember(payload)
                console.log('USER_CMS_INFO info', res)
                if (res.data.status === 200) {
                    commit('USER_CMS_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('USER_CMS_INFO', error)
            }
        },
        // @Description CMS등록
        async REG_CMS_USER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.cmsMember(payload)
                console.log('REG_CMS_USER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('USER_CMS_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REG_CMS_USER', error)
            }
        },
        // @Description CMS출금요청
        async WITHDRAWAL_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.cmsPaymentReq(payload)
                console.log('WITHDRAWAL_APPLY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('WITHDRAWAL_APPLY', error)
            }
        },
        // @Description CMS출금재요청
        async WITHDRAWAL_RE_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.cmsPaymentReReq(payload)
                console.log('WITHDRAWAL_RE_APPLY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('WITHDRAWAL_RE_APPLY', error)
            }
        },
        // @Description CMS출금요청 삭제
        async DELETE_CMS_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.cmsPayment(payload)
                console.log('DELETE_CMS_APPLY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_CMS_APPLY', error)
            }
        },
        // @Description CMS회원상태 최신정보로 조회
        async SYNC_MEMBER_STATE({ commit }, payload) {
            try {
                res = await recipient.get.cmsMember(payload)
                console.log('SYNC_MEMBER_STATE info', res)
                if (res.data.status === 200) {
                    commit('USER_CMS_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('SYNC_MEMBER_STATE', error)
            }
        },
        // @Description 출금요청리스트 최신정보로 조회
        async SYNC_PAYMENT_STATE({ commit }, payload) {
            try {
                res = await recipient.get.cmsPaymentApi(payload)
                console.log('SYNC_PAYMENT_STATE info', res)
                if (res.data.status === 200) {
                    commit('CMS_PAYMENT_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('SYNC_PAYMENT_STATE', error)
            }
        },
        // @Description 회원정보 변경 전 출금요청된 내역이 있는지 확인
        async PAYING_COUNT({ commit }, payload) {
            try {
                res = await recipient.get.cmsPayingCount(payload)
                console.log('PAYING_COUNT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('PAYING_COUNT', error)
            }
        },
        // @Description CMS회원정보 삭제
        async DELETE_CMS_USER({ commit }, payload) {
            try {
                res = await recipient.delete.cmsMember(payload)
                console.log('DELETE_CMS_USER info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                return res.data
            } catch (error) {
                console.error('DELETE_CMS_USER', error)
            }
        },
        // @Description CMS출금내용으로 자동수납처리
        async SYNC_DEPOSIT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.cmsPaymentDeposit(payload)
                console.log('SYNC_DEPOSIT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNC_DEPOSIT', error)
            }
        },
        // @Description 본부금화면 - 개인의료비공제 엑셀다운로드
        async HOMETAX_MEDICAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.medicalExpense(payload)
                console.log('HOMETAX_MEDICAL info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('HOMETAX_MEDICAL', error)
            }
        },
        // @Description 개인별장기이용계획 변경사유서의 변경전/변경후 수가조회
        async NUMBER_CODES_YEAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.numberCodesYear(payload)
                console.log('NUMBER_CODES_YEAR info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('NUMBER_CODES_YEAR', error)
            }
        },
        // @Description 급여제공계획변경 사유서 리스트 조회
        async SERVICE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.offerPlanChange(payload)
                console.log('SERVICE_PLAN info', res)
                if (res.data.status === 200) {
                    commit('SERVICE_PLAN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_PLAN', error)
            }
        },
        // @Description 급여제공계획변경 사유서 저장/수정
        async UPDATE_SERVICE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.offerPlanChange(payload)
                console.log('UPDATE_SERVICE_PLAN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_SERVICE_PLAN', error)
            }
        },
        // @Description 급여제공계획변경 사유서 삭제
        async DELETE_SERVICE_PLAN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.offerPlanChange(payload)
                console.log('DELETE_SERVICE_PLAN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_SERVICE_PLAN', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_SERVICE_PLAN', error)
            }
        },
        // @Description 급여제공계획변경 사유서 관련문서 조회
        async SERVICE_REL_DOC({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.relatedDoc(payload)
                console.log('SERVICE_REL_DOC info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SERVICE_REL_DOC', error)
            }
        },
        // @Description 급여제공계획변경 사유서 프린트
        async PLAN_CHANGE_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.planChangePrint(payload)
                console.log('PLAN_CHANGE_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PLAN_CHANGE_PRINT', error)
            }
        },
        // @Description 응급상황기록부 리스트 조회(결재)
        async EMERGENCY_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.emergencyList(payload)
                console.log('EMERGENCY_LIST info', res)
                if (res.data.status === 200) {
                    commit('EMERGENCY_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMERGENCY_LIST', error)
            }
        },
        // @Description 본인부담금 동기화 상태 조회
        async GET_STATUS_SYNC_BAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.syncStatusBar(payload)
                console.log('GET_STATUS_SYNC_BAR info', res)
                if (res.data.status === 200) {
                    commit('GET_STATUS_SYNC_BAR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_STATUS_SYNC_BAR', error)
            }
        },
        // @Description 급여제공기록지 수정(방문요양)
        async UPDATE_CARE_REPORT_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.updateCareLog(payload)
                console.log('UPDATE_CARE_REPORT_LOG info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_CARE_REPORT_LOG', error)
            }
        },
        // @Description 급여제공기록지 수정(방문요양)
        async UPDATE_BATH_REPORT_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.updateBathLog(payload)
                console.log('UPDATE_BATH_REPORT_LOG info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BATH_REPORT_LOG', error)
            }
        },
        // @Description 업무수행일지 신규버전 조회 
        async GET_WORK_PERFORMANCE_LOGS_MONTHLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.workPerformanceLogsMonthly(payload)
                console.log('getWorkPerformanceLogs info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } 
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('getWorkPerformanceLogs', error)
            }
        },
        // @Description 업무수행일지 신규버전 연간(매트릭스) 조회
        async GET_WORK_DIARY_YEARLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.recipientDiaryYearly(payload)
                console.log('GET_WORK_DIARY_YEARLY info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_WORK_DIARY_YEARLY', error)
            }
        },
        // @Description 업무수행일지 등록
        async REGSIT_WORK_PERFORMANCE_LOGS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.registWorkPerformanceLogs(payload)
                console.log('REGSIT_WORK_PERFORMANCE_LOGS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGSIT_WORK_PERFORMANCE_LOGS', error)
            }
        },
        async DETAIL_WORK_PERFORMANCE_LOGS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.detailWorkPerformanceLogs(payload)
                console.log('DETAIL_WORK_PERFORMANCE_LOGS info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } 
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DETAIL_WORK_PERFORMANCE_LOGS', error)
            }
        },
        // @Description 업무수행일지 상세 조회
        async GET_WORK_CASENOTE_LOG({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.aCasenoteLog(payload)
                console.log('GET_WORK_CASENOTE_LOG info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } 
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_WORK_CASENOTE_LOG', error)
            }
        },
        async DELETE_WORK_PERFORMANCE_LOGS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.delete.workPerformanceLogs(payload)
                console.log('DELETE_WORK_PERFORMANCE_LOGS info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_WORK_PERFORMANCE_LOGS', error)
            }
        },
        // @Description 상태변화기록지 수정
        async EDIT_DAILY_STATUS_NOTE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.post.updateDailyStatusNote(payload)
                console.log('EDIT_DAILY_STATUS_NOTE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EDIT_DAILY_STATUS_NOTE', error)
            }
        },
        // @Description 요양보호사 기준 수급자 조회 (26.02.10 테스트 필요)
        async GET_CAREGIVER_SIMPLE_RECIPIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await recipient.get.careSimpleRecipient(payload)
                console.log('GET_CAREGIVER_SIMPLE_RECIPIENT info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } 
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_CAREGIVER_SIMPLE_RECIPIENT', error)
            }
        },
    },
    getters: {
        /**
         * @author 김정원
         * @since 25.05.27
         * @brief 계약서 선택사항 변경
        */
        CONTRACT_SERVICE_TYPE: state => {
            return state.contractServiceType
        },
        SET_SESSION() {
            sessionStorage.getItem("rdu", btoa("n").replace(/=/g, ""))
        },
        PROCESS_COPAY: state => {
            console.log("call process data after clicked", state.processStatus)
            if (state.processStatus) {
                return {
                    status: true,
                    index: state.processPayload.indexNo,
                    data: state.processPayload.data,
                    processName: state.processName,
                }
            } else {
                return false
            }
        },
        RECIPIENT_SIMPLE: state => {
            let arr = null
            state.selected = []
            if (!state.recipientSimple) return

            // state = contract
            if (state.state) {
                if (state.state === '91') // 1등급
                    arr = state.recipientSimple.filter(item => item.longtermCareGradeCode === '1')
                else if (state.state === '92') // 2등급
                    arr = state.recipientSimple.filter(item => item.longtermCareGradeCode === '2')
                else if (state.state === '93') // 3등급
                    arr = state.recipientSimple.filter(item => item.longtermCareGradeCode === '3')
                else if (state.state === '94') // 4등급
                    arr = state.recipientSimple.filter(item => item.longtermCareGradeCode === '4')
                else if (state.state === '95') // 5등급
                    arr = state.recipientSimple.filter(item => item.longtermCareGradeCode === '5')
                else
                    arr = state.recipientSimple.filter(item => item.suadeContractStateCode === state.state)
            } else {
                arr = state.recipientSimple
            }

            // listType = arranger: compare with list type code for social walfare and nurse in person of recipient
            if (state.listType === '99') { // my recipients
                arr = arr.filter(item => item.myReceiverYn === 'Y')
            } else if (state.listType === '98') { // remainDays <= 90
                arr = arr.filter(item => item.remainDays <= 90)
            } else if (state.listType === 'care') {
                arr = arr.filter(item => item.careSuadeContractStateYn === 'Y')
            } else if (state.listType === 'bath') {
                arr = arr.filter(item => item.bathSuadeContractStateYn === 'Y')
            } else if (state.listType !== null && state.listType !== false) {
                arr = arr.reduce((forward, current) => {
                    if (current.staffChargeInfos && current.staffChargeInfos.length > 0) {
                        if (current.staffChargeInfos.some(person => person.userIdx === state.listType))
                            forward.push(current)
                    }
                    return forward
                }, [])
            }

            // searching keyword
            if (state.searchWord) {
                if (pattern.test(state.searchWord)) {
                    arr = arr.filter(item => {
                        if (item.phoneNo) return item.phoneNo.includes(state.searchWord.replace(/-/g, ''))
                    })
                } else {
                    arr = arr.filter(item => item.seniorName.includes(state.searchWord))
                }
            }
            return state.copiedRecipients = arr
        },
        RECIPIENT: state => {
            let arr = null
            state.selected = []
            if (!state.recipients) return

            // state = contract
            if (state.state) {
                if (state.state === '91') // 1등급
                    arr = state.recipients.filter(item => item.longtermCareGradeCode === '1')
                else if (state.state === '92') // 2등급
                    arr = state.recipients.filter(item => item.longtermCareGradeCode === '2')
                else if (state.state === '93') // 3등급
                    arr = state.recipients.filter(item => item.longtermCareGradeCode === '3')
                else if (state.state === '94') // 4등급
                    arr = state.recipients.filter(item => item.longtermCareGradeCode === '4')
                else if (state.state === '95') // 5등급
                    arr = state.recipients.filter(item => item.longtermCareGradeCode === '5')
                else
                    arr = state.recipients.filter(item => item.suadeContractStateCode === state.state)
            } else {
                arr = state.recipients
            }

            // listType = arranger: compare with list type code for social walfare and nurse in person of recipient
            if (state.listType === '99') { // my recipients
                arr = arr.filter(item => item.myReceiverYn === 'Y')
            } else if (state.listType === '98') { // remainDays <= 90
                arr = arr.filter(item => item.remainDays <= 90)
            } else if (state.listType === 'care') {
                arr = arr.filter(item => item.careSuadeContractStateYn === 'Y')
            } else if (state.listType === 'bath') {
                arr = arr.filter(item => item.bathSuadeContractStateYn === 'Y')
            } else if (state.listType !== null && state.listType !== false) {
                arr = arr.reduce((forward, current) => {
                    if (current.staffChargeInfos && current.staffChargeInfos.length > 0) {
                        if (current.staffChargeInfos.some(person => person.userIdx === state.listType))
                            forward.push(current)
                    }
                    return forward
                }, [])
            }

            // searching keyword
            if (state.searchWord) {
                if (pattern.test(state.searchWord)) {
                    arr = arr.filter(item => {
                        if (item.phoneNo) return item.phoneNo.includes(state.searchWord.replace(/-/g, ''))
                    })
                } else {
                    arr = arr.filter(item => item.seniorName.includes(state.searchWord))
                }
            }
            return state.copiedRecipients = arr
        },

        RECIPIENT_CONTRACT: state => {
            if (state.contracts) {
                return state.contracts.suadeContractList[0]
            }
        },
        RECIPIENT_RENEW_CONTRACT: state => {
            if (state.renewContracts) {
                let obj = state.renewContracts.suadeContractList[0]
                let pre = obj.contractInfo.rno3 ? atob(decodeURIComponent(obj.contractInfo.rno3)) : null
                let back = obj.contractInfo.rnoEnc ? atob(decodeURIComponent(obj.contractInfo.rnoEnc)) : null
                obj.contractInfo['rnoSum'] = pre ? pre + back : null

                if (obj.contractInfo.phoneNo) obj.contractInfo.phoneNo = obj.contractInfo.phoneNo.mobileMask()
                if (obj.contractInfo.telNo) obj.contractInfo.telNo = obj.contractInfo.telNo.mobileMask()
                if (obj.contractInfo.suadeContractReStartYmd) obj.contractInfo.suadeContractReStartYmd = obj.contractInfo.suadeContractReStartYmd.ymdMask()
                if (obj.contractInfo.suadeContractReEndYmd) obj.contractInfo.suadeContractReEndYmd = obj.contractInfo.suadeContractReEndYmd.ymdMask()

                return obj
            }
        },
        RECIPIENT_RENEW: state => {
            if (state.renewAll) {
                let pre = state.renewAll.contractInfo.rno3 ? atob(decodeURIComponent(state.renewAll.contractInfo.rno3)) : null
                let back = state.renewAll.contractInfo.rnoEnc ? atob(decodeURIComponent(state.renewAll.contractInfo.rnoEnc)) : null
                state.renewAll.contractInfo['rnoSum'] = pre ? pre + back : null

                if (state.renewAll.contractInfo.phoneNo) state.renewAll.contractInfo.phoneNo = state.renewAll.contractInfo.phoneNo.mobileMask()
                if (state.renewAll.contractInfo.telNo) state.renewAll.contractInfo.telNo = state.renewAll.contractInfo.telNo.mobileMask()
                if (state.renewAll.contractInfo.authPeriodStartYmd) state.renewAll.contractInfo.authPeriodStartYmd = state.renewAll.contractInfo.authPeriodStartYmd.ymdMask()
                if (state.renewAll.contractInfo.authPeriodEndYmd) state.renewAll.contractInfo.authPeriodEndYmd = state.renewAll.contractInfo.authPeriodEndYmd.ymdMask()
                if (state.renewAll.contractInfo.suadeContractStartYmd) state.renewAll.contractInfo.suadeContractStartYmd = state.renewAll.contractInfo.suadeContractStartYmd.ymdMask()
                if (state.renewAll.contractInfo.suadeContractEndYmd) state.renewAll.contractInfo.suadeContractEndYmd = state.renewAll.contractInfo.suadeContractEndYmd.ymdMask()
                if (state.renewAll.contractInfo.seniorBirthday) state.renewAll.contractInfo.seniorBirthday = state.renewAll.contractInfo.seniorBirthday.ymdMask()

                if (state.renewAll.contractInfo.salaryList) {
                    state.renewAll.contractInfo.salaryList.forEach(item => {
                        item.startTimeHm = item.startTimeHm.timeMask()
                        item.endTimeHm = item.endTimeHm.timeMask()
                    })
                }

                return state.renewAll
            }
        },
        LATEST_CARE: state => {
            if (state.latestCare) {
                let obj = state.latestCare
                let pre = obj.rno3 ? atob(decodeURIComponent(obj.rno3)) : null
                let back = obj.rnoEnc ? atob(decodeURIComponent(obj.rnoEnc)) : null
                obj['rnoSum'] = pre ? pre + back : null
                if (obj.phoneNo) obj.phoneNo = obj.phoneNo.mobileMask()
                if (obj.telNo) obj.telNo = obj.telNo.mobileMask()
                if (obj.suadeContractStartYmd) obj.suadeContractStartYmd = obj.suadeContractStartYmd.ymdMask()
                if (obj.suadeContractEndYmd) obj.suadeContractEndYmd = obj.suadeContractEndYmd.ymdMask()

                obj['signList'] = {
                    guardianSignatureFileIdx: null,
                    guardianName: null,
                    receiverSignatureFileIdx: null,
                    receiverName: obj.seniorName
                }
                if (obj.commonSignatureList) {
                    obj.commonSignatureList.forEach(item => {
                        if (item.signerTypeCode === '11' && item.signatureYmdhms) {
                            obj.signList.receiverSignatureFileIdx = item.digitalSignatureFileIdx
                            obj.signList.receiverName = item.signUserName
                        } else if (item.signerTypeCode === '13' && item.signatureYmdhms) {
                            obj.signList.guardianSignatureFileIdx = item.digitalSignatureFileIdx
                            obj.signList.guardianName = item.signUserName
                        }
                    })
                }

                return obj
            }
        },
        LATEST_BATH: state => {
            if (state.latestBath) {
                let obj = state.latestBath
                let pre = obj.rno3 ? atob(decodeURIComponent(obj.rno3)) : null
                let back = obj.rnoEnc ? atob(decodeURIComponent(obj.rnoEnc)) : null
                obj['rnoSum'] = pre ? pre + back : null
                if (obj.phoneNo) obj.phoneNo = obj.phoneNo.mobileMask()
                if (obj.telNo) obj.telNo = obj.telNo.mobileMask()
                if (obj.suadeContractStartYmd) obj.suadeContractStartYmd = obj.suadeContractStartYmd.ymdMask()
                if (obj.suadeContractEndYmd) obj.suadeContractEndYmd = obj.suadeContractEndYmd.ymdMask()

                obj['signList'] = {
                    guardianSignatureFileIdx: null,
                    guardianName: null,
                    receiverSignatureFileIdx: null,
                    receiverName: obj.seniorName
                }
                if (obj.commonSignatureList) {
                    obj.commonSignatureList.forEach(item => {
                        if (item.signerTypeCode === '11' && item.signatureYmdhms) {
                            obj.signList.receiverSignatureFileIdx = item.digitalSignatureFileIdx
                            obj.signList.receiverName = item.signUserName
                        } else if (item.signerTypeCode === '13' && item.signatureYmdhms) {
                            obj.signList.guardianSignatureFileIdx = item.digitalSignatureFileIdx
                            obj.signList.guardianName = item.signUserName
                        }
                    })
                }

                return obj
            }
        },
        RECIPIENT_RENEW_LIST: state => {
            if (state.contractChange) {
                let arr = state.contractChange
                arr.forEach(item => {
                    let pre = item.rno3 ? atob(decodeURIComponent(item.rno3)) : null
                    let back = item.rnoEnc ? atob(decodeURIComponent(item.rnoEnc)) : null
                    item['rnoSum'] = pre ? pre + back : null

                    if (item.phoneNo) item.phoneNo = item.phoneNo.mobileMask()
                    if (item.telNo) item.telNo = item.telNo.mobileMask()
                    if (item.suadeContractReStartYmd) item.suadeContractReStartYmd = item.suadeContractReStartYmd.ymdMask()
                    if (item.suadeContractReEndYmd) item.suadeContractReEndYmd = item.suadeContractReEndYmd.ymdMask()

                    item['signList'] = {
                        guardianSignatureFileIdx: null,
                        guardianName: null,
                        receiverSignatureFileIdx: null,
                        receiverName: item.seniorName
                    }

                    if (item.commonSignatureList) {
                        item.commonSignatureList.forEach(sign => {
                            if (sign.signerTypeCode === '11' && sign.signatureYmdhms) {
                                item.signList.receiverSignatureFileIdx = sign.digitalSignatureFileIdx
                                item.signList.receiverName = sign.signUserName
                            } else if (sign.signerTypeCode === '13' && sign.signatureYmdhms) {
                                item.signList.guardianSignatureFileIdx = sign.digitalSignatureFileIdx
                                item.signList.guardianName = sign.signUserName
                            }
                        })
                    }

                })
                return arr
            }
        },
        SELECTED_IDX: state => {
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.userIdx)
                })
            }
            return arr
        },
        SELECTED_HIDX: state => {
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.homeSeniorIdx)
                })
            }
            return arr
        },
        SELECTED_SCIDX: state => {
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.suadeContractIdx)
                })
            }
            return arr
        },
        SELECTED_HRIDX: state => {
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.homeReceiverIdx)
                })
            }
            return arr
        },
        CAL_SELECTED_HIDX: state => {
            if (state.calendarIdx) {
                return Number(state.calendarIdx.homeReceiverIdx)
            } else {
                return null
            }
        },
        FILE_LIST: state => {
            let ess1 = null
            let ess2 = null
            let ess3 = null
            let ess4 = null
            let ess5 = null
            if (state.suadeContractFileList) {
                state.suadeContractFileList.forEach(item => {
                    if (item.suadeContractEssentialTypeCode === '11') {
                        if (!ess1) ess1 = []
                        ess1.push(item)
                    } else if (item.suadeContractEssentialTypeCode === '12') {
                        ess2 = item
                    } else if (item.suadeContractEssentialTypeCode === '13') {
                        ess3 = item
                    } else if (item.suadeContractEssentialTypeCode === '14') {
                        if (!ess4) ess4 = []
                        ess4.push(item)
                    } else if (item.suadeContractEssentialTypeCode === '19') {
                        if (!ess5) ess5 = []
                        ess5.push(item)
                    }
                })
            }
            return {
                ess1: ess1, //표장기
                ess2: ess2, //등급인정서
                ess3: ess3, //복지용구
                ess4: ess4, //방문간호지시서
                ess5: ess5 //장기요양기관 입소/이용의뢰서
            }

        },
        // CHARGE_STAFF: state => {
        //     let index = state.staffInfo.findIndex(item => (item.staffTypeCode==='31'||item.staffTypeCode==='32'||item.staffTypeCode==='33'||item.staffTypeCode==='34')&&item.chargeStateCode==='11')
        //     console.log(state.staffInfo)
        //     console.log(index)
        //     if(index !== -1) {
        //         return state.staffInfo[index]
        //     } else {
        //         return {
        //             staffUserName: '미등록'
        //         }
        //     }
        // },
        // SALARYS: state => {
        //     return state.salarys
        // },
        RECEIVER_ITEMS: state => {
            let arr = []

            if (state.recipientDetail) {
                console.log("add receiver items", state.guardianInfos)
                if (state.recipientDetail && state.recipientDetail.phoneNo) {
                    arr.push({
                        name: state.recipientDetail.seniorName + ' <본인>',
                        mobileNo: state.recipientDetail.phoneNo,
                    })
                }
                if (state.guardianInfos) {
                    state.guardianInfos.forEach(item => {
                        arr.push({
                            name: `${item.userName} <${item.guardianRelatCodeName}>`,
                            mobileNo: item.mobileNo
                        })
                    })
                }
            }

            arr.push({
                name: '직접입력',
                mobileNo: null
            })

            return arr
        },
        SELECT_RECIPIENT: state => {
            if (state.recipients && state.selected && state.selected.length >= 1) {
                let arr = []

                state.selected.forEach((element, ei) => {
                    state.recipients.forEach((senior) => {
                        if (element.userIdx === senior.userIdx) {
                            state.selected[ei]["userName"] = senior.seniorName
                            state.selected[ei]["birthday"] = senior.seniorBirthday

                            arr.push(senior.seniorName)
                        }
                    })
                })
                return arr
            } else {
                return null
            }
        },
        // COPAYS: state => {
        //     let copays = [],
        //         item, currentYmd, now, ym, dd
        //     if (state.personalCopayList) {
        //         state.personalCopayList.forEach((element) => {

        //             if (element.depositYmd) {
        //                 currentYmd = element.depositYmd.ymdMask()
        //             } else {
        //                 now = new Date()
        //                 ym = now.toISOString().substr(0, 7)
        //                 dd = new Date(element.chargeYm.substr(0, 4), element.chargeYm.substr(4, 2), 0).getDate()

        //                 //console.log("check on vuex - depositYmd", currentYmd, element.chargeYm.substr(0, 4), element.chargeYm.substr(4, 2), dd)
        //                 currentYmd = (Number(element.chargeYm) < Number(ym.replace(/-/g, ''))) ?
        //                     (element.chargeYm + dd).ymdMask() :
        //                     now.toISOString().substr(0, 10)
        //             }
        //             item = {
        //                 advanceAmount: element.advanceAmount,
        //                 chargeAmount: element.chargeAmount,
        //                 chargeYm: element.chargeYm,
        //                 copayAmount: element.copayAmount,
        //                 // corpChargeAmount: element.corpChargeBathAmount + element.corpChargeCareAmount + element.corpChargeNurseAmount,
        //                 corpChargeBathAmount: element.corpChargeBathAmount,
        //                 corpChargeCareAmount: element.corpChargeCareAmount,
        //                 corpChargeNurseAmount: element.corpChargeNurseAmount,
        //                 depositBalanceAmount: element.depositBalanceAmount,
        //                 guardianUserIdx: element.guardianUserIdx,
        //                 homeReceiverIdx: element.homeReceiverIdx,
        //                 limitAmount: element.limitAmount,
        //                 longtermCareGradeCodeName: element.longtermCareGradeCodeName,
        //                 monthUseLimitAmount: element.monthUseLimitAmount,
        //                 personalBathAmount: element.personalBathAmount,
        //                 personalCareAmount: element.personalCareAmount,
        //                 personalChargeAmount: element.personalChargeBathAmount + element.personalChargeCareAmount + element.personalChargeNurseAmount,
        //                 personalChargeBathAmount: element.personalChargeBathAmount,
        //                 personalChargeCareAmount: element.personalChargeCareAmount,
        //                 personalChargeNurseAmount: element.personalChargeNurseAmount,
        //                 personalChargeRatio: element.personalChargeRatio,
        //                 personalChargeSalaryHistoryIdx: element.personalChargeSalaryHistoryIdx,
        //                 personalChargeTypeCodeName: element.personalChargeTypeCodeName,
        //                 personalFamilyAmount: element.personalFamilyAmount,
        //                 personalNurseAmount: element.personalNurseAmount,
        //                 personalRecogAmount: element.personalRecogAmount,
        //                 phoneNo: element.phoneNo,
        //                 prevDepositBalanceAmount: element.prevDepositBalanceAmount,
        //                 prevUnpaidAmount: element.prevUnpaidAmount,
        //                 seniorBirthday: element.seniorBirthday,
        //                 seniorGender: element.seniorGender,
        //                 seniorName: element.seniorName,
        //                 serviceBathCount: element.serviceBathCount,
        //                 serviceCareCount: element.serviceCareCount,
        //                 serviceDayCount: element.serviceDayCount,
        //                 serviceNurseCount: element.serviceNurseCount,
        //                 serviceYm: element.serviceYm,
        //                 suadeContractIdx: element.suadeContractIdx,
        //                 thisMonthDepositAmount: element.thisMonthDepositAmount,
        //                 thisYearCopayAmount: element.thisYearCopayAmount,
        //                 thisYearDepositAmount: element.thisYearDepositAmount,
        //                 userIdx: element.userIdx,
        //                 depositYmd: currentYmd,
        //                 depositAmount: element.depositBalanceAmount && String(element.depositBalanceAmount).substr(0, 1) === '-' ?
        //                     0 : element.depositBalanceAmount.amount(),
        //                 payMethodCode: '12',
        //                 depositorName: element.depositorName,
        //                 depositMemo: null,
        //             }

        //             copays.push(item)
        //         })
        //     } else {
        //         copays = null
        //     }
        //     return copays
        // },
        /**
         * 
         * @function COPAYSCHECK
         * @description : 본부금 체크박스 선택시 선별  
         */
        COPAYSCHECK: state => {
            let copays = []
            if (state.personalCopayList) {
                copays = state.personalCopayList.filter(item => {
                    if (state.idxGroup.includes(item.homeReceiverIdx)) return true
                })
            } else {
                copays = null
            }
            return copays
        },
        // @Description 급여제공계획 구분에 따른 필요영역 가져오기
        SERVICE_PROVIDE_PLAN_NEED_AREA: state => {
            if (state.planNeedAreas) {
                return state.planNeedAreas.reduce((forward, it) => {
                    forward.push({ value: it.detailCode, text: it.detailName })
                    return forward
                }, [])
            }
        },
        // @Description 급여제공계획 필요영역 선택에 따른 세부영역 만들기
        SERVICE_PROVIDE_PLAN_NEED_SUB_AREA: state => {
            if (state.planSubAreaItems) {
                return state.planSubAreaItems.reduce((forward, it) => {
                    if (forward.length <= 0) {
                        forward.push({
                            value: it.ltcareNo,
                            text: it.needContentLtcare,
                            needTargetGroupCode: it.needTargetGroupCode,
                            needTargetGroupDetailCode: it.needTargetGroupDetailCode
                        })
                    } else {
                        if (typeof forward.find((n) => (n.value === it.ltcareNo)) === 'undefined') {
                            forward.push({
                                value: it.ltcareNo,
                                text: it.needContentLtcare,
                                needTargetGroupCode: it.needTargetGroupCode,
                                needTargetGroupDetailCode: it.needTargetGroupDetailCode
                            })
                        }
                    }

                    return forward
                }, [])
            }
        },
        SELECT_COPAY: state => {
            if (state.selectCopaySuadeIdx && state.personalCopay) {
                let index = state.personalCopay.findIndex(item => item.suadeContractIdx === state.selectCopaySuadeIdx)
                return state.personalCopay[index]
            } else {
                return null
            }
        },
        PERSONAL_GUARDIAN_COUNT: state => {
            let count = 0
            if (state.personalCopay) {
                state.personalCopay.forEach(item => {
                    if (item.guardianUserIdx) {
                        count += 1
                    }
                })
            }
            return count
        },
        CONTRACT_STATUS_ON_LIST: state => { return state.state },
        RECIPIENT_LIST_TYPE_ON_LIST: state => { return state.listType },
        SALARY_NUMBER_TYPE_CODES: state => { return state.salaryNumberCodes },
        STATUS_WORKING_PROGRESS: state => { return (state.statusWorkingProgress) ? state.statusWorkingProgress.rtnList : [] },
        STATUS_USING_BETWEEN_PAYMENTS: state => { return (state.statusUsingAmount) ? state.statusUsingAmount.rtnList : [] },
        STATUS_SUPPORT_ADDITION: state => { return state.additionSupportAmount ? state.additionSupportAmount : [] },
        SET_OFFER_LIST: state => {
            if (state.offerList) {
                let arr = state.offerList.deepCopy()
                arr.forEach((item, i) => {
                    item['no'] = i
                    item['start'] = `${item.offerYmd.ymdMask()} ${item.startHm.timeMask()}:00`
                    item['end'] = `${item.offerYmd.ymdMask()} ${item.endHm.timeMask()}:00`
                    item['color'] = 'white'
                })
                return arr
            } else {
                return []
            }
        },
        STAFF_PAYMENT_TEMP: state => {
            let arr = []
            let staffs = []
            if (state.offerStaffList && state.offerList) {
                //일정에서 idx확인
                state.offerList.forEach(item => {
                    let tmp = String(item.staffUserIdxs).split('/')
                    tmp.forEach(item => {
                        if (!arr.includes(Number(item))) {
                            arr.push(Number(item))
                        }
                    })
                })

                //직원리스트에서 일정에 포함된 직원의 정보 찾기
                state.offerStaffList.forEach(item => {
                    if (arr.includes(Number(item.staffUserIdx))) {
                        item.salaryNumberList.forEach(sal => {
                            sal.count = 0
                        })
                        arr.push(Number(item.staffUserIdx))
                        staffs.push(item)
                    }
                })

                staffs.forEach(item => {
                    let tmpOffer = state.offerList.filter(offer => {
                        let tmpIdx = String(offer.staffUserIdxs).split('/')
                        if (tmpIdx.includes(String(item.staffUserIdx))) {
                            return true
                        }
                    })
                    tmpOffer.forEach(service => {
                        let index = item.salaryNumberList.findIndex(sal =>
                            sal.salaryNumberTypeCode === service.numberCode.substr(0, 5)
                        )
                        if (index !== -1) {
                            item.salaryNumberList[index].count += 1
                        }
                    })
                })
            }

            return staffs
        },
        FILTERED_SALARY_NUMBER_CODES: state => {
            if (state.numbersType && state.salaryNumberCodes) {
                if (state.numbersType === '11') {
                    if (state.familyYn) {
                        return state.salaryNumberCodes.filter(item => item.numberCode === 'B1206000' || item.numberCode === 'B1209000')
                    } else {
                        return state.salaryNumberCodes.filter(item => item.homeServiceTypeCode === state.numbersType && item.numberCode !== 'B1206000' && item.numberCode !== 'B1209000')
                    }
                } else {
                    return state.salaryNumberCodes.filter(item => item.homeServiceTypeCode === state.numbersType)
                }
            } else {
                return state.salaryNumberCodes
            }
        },
        /**
         * @function CMS_MEMBER_LIST
         * @description 본부금 CMS 청구리스트 Getters
         */
        CMS_MEMBER_LIST: state => {
            if (state.cmsMemberList) {
                state.cmsMemberList.forEach(payment => {
                    payment.actualAmount = payment.copayAmount ? payment.copayAmount.amount() : ''
                    payment.paymentDate = payment.paymentDate ? payment.paymentDate.ymdMask() : ''
                })
                return state.cmsMemberList
            } else {
                return []
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/recipients.js